<template>
  <div class="detailWrap" v-cloak>
    <div class="nativeWrap" :style="`height:${height * 1 + 34}px;`">
      <div class="backImg">
        <img class="backrightImg" @click="clickback" src="../assets/leftbtn.jpg" alt="">
        <div class="imgName" v-if="list.anchor">
          <img class="imgNameimg" :src="list.anchor.avatar" alt="">
          <div class="topName">{{list.anchor.userName}}</div>
        </div>
      </div>
      <img class="rightImg" @click="clickmore" src="https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/prod/temp/%E6%9B%B4%E5%A4%9A.png" alt="">
    </div>
    <!-- <div :style="`margin-top:${height * 1}px;`"> -->
      <!-- <div class="sumBox">{{sum}}{{maxCount}}</div><div @click="groupTeamdetail">btn</div> -->
      <div class="shareWrap" v-if="shareList.info && shareList.info.length > 0 && (list.status == 3 || list.status == 2)"><div class="shareText">点击“...”分享到微信，好友助力获奖励<img src="" alt=""></div></div>
      <div class="banner" v-if="banners && banners.length > 0">
        <!-- <div @click="updateStatus">updateStatus</div> -->
        <van-swipe class="my-swipe" indicator-color="#fff" @change="onChange">
          <van-swipe-item v-for="(item, index) in banners" :key="index" @click="clickImg(banners, index)">
            <van-image
              :src="item.url"
            />
            <!-- <van-image
              src="https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/temp/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250623200027.jpg"
            /> -->
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">{{ current + 1 }}/{{banners.length}}</div>
          </template>
        </van-swipe>
      </div>
      <div class="banner" v-else>
      </div>
      <div class="card-box">
        <div class="card-box-left">
          <div class="card-box-left-title" v-if="list.type != 11" @click="clickcard()">精美卡片<img style="width:.14rem;height:.14rem;margin-left:.03rem;" src="../assets/Vector.png" /></div>
          <div class="card-box-left-money" v-if="list.payType == 5">仅兑换券</div>
          <div class="card-box-left-money" v-else><span>¥</span>{{list.signPriceStr}}</div>
        </div>
        <!-- ==2距开售   ==3 距结束 -->
        <div class="card-box-right" v-if="list.status == 3">
          <template v-if="time >= 0">
            <div class="card-box-right-top">距结束</div>
            <div class="flexs">
              <van-count-down :time="time" style="margin-right:.05rem;" format="DD天" />
              <van-count-down :time="time" @finish="handleFinish">
                <template #default="time">
                  <span class="block">{{ time.hours >= 10 ? time.hours : '0' + time.hours }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ time.minutes >= 10 ? time.minutes : '0' + time.minutes }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ time.seconds >= 10 ? time.seconds : '0' + time.seconds }}</span>
                </template>
              </van-count-down>
            </div>
          </template>
          <template v-else><div style="margin-left:.3rem;margin-top:.1rem;">已结束</div></template>
        </div>
        <div class="card-box-right" v-else-if="list.status == 2">
          <template v-if="sellTimeStr >= 0">
            <div class="card-box-right-top">距开售</div>
            <div class="flexs">
              <van-count-down :time="sellTimeStr" style="margin-right:.05rem;" format="DD天"/>
              <van-count-down :time="sellTimeStr" @finish="handleFinish">
                <template #default="sellTimeStr">
                  <span class="block">{{ sellTimeStr.hours >= 10 ? sellTimeStr.hours : '0' + sellTimeStr.hours }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ sellTimeStr.minutes >= 10 ? sellTimeStr.minutes : '0' + sellTimeStr.minutes }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ sellTimeStr.seconds >= 10 ? sellTimeStr.seconds : '0' + sellTimeStr.seconds}}</span>
                </template>
              </van-count-down>
            </div>
          </template>
          <template v-else><div style="margin-left:.3rem;margin-top:.1rem;">{{list.statusName}}</div></template>
        </div>
        <div class="card-box-right" v-else-if="list.status == 5">
          <template>
            <div class="card-box-right-top">待拆卡</div>
            <div class="flexs">{{list.liveTaskTime}}</div>
          </template>
        </div>
        <div class="card-box-right" style="margin-top:.2rem;margin-left:.2rem;text-align:center;font-size:.15rem;font-weight:500;" v-else>{{list.statusName}}</div>
      </div>
      <!--//是否展示背景图片 :style="!this.$route.query.type ? 'background: transparent' : 'background: url(`../assets/back.png`) no repeat;background-size:100% 100%;'" -->
      <div class="card-wrap">
        <!-- <VerticalTextSlider v-if="list.type == 2 || list.type == 3" :sliderData="sliderData" :interval="3000" :height="30" /> -->
        <Chinaopen :image="imageUrl" :rightAngle="rightAngle" v-if="list.competitionId == 20" style="width:3.75rem;margin-top: -.2rem;margin-bottom: .1rem;margin-left: -.16rem;"/>
        <div class="jianWrap" v-if="sliderData.length" ref="scrollContainer">
          <div v-for="(items, indexs) in sliderData" :key="indexs" class="couponList">{{items.titles}} {{items.title}}</div>
        </div>
        <div class="card-wrap-box">
          <div class="card-number">编号 {{list.serial}}</div>
          <div class="progress-box">
            <!-- <div class="progress-box-surplus" :style="`width:${(total - (total - surplus)) / total * 100}%`" v-if="(total - (total - surplus)) / total * 100 + '%' >= 50 + '%' || (total - (total - surplus)) / total * 100 + '%' == 100 + '%'"></div>
            <div class="progress-box-surpluss" :style="`width:${(total - (total - surplus)) / total * 100}%`" v-else></div> -->
            <div class="progress-box-surplus" :style="`width:${surplus / total * 100}%`" v-if="surplus / total * 100 >= 51"></div>
            <div class="progress-box-surpluss" :style="`width:${surplus / total * 100}%`" v-else></div>
          </div>
          <div class="onsale">
            <div class="onsale-left">开售 {{list.sellTime}}</div>
            <div class="onsale-right">余 {{(total - surplus)  + ' / 共' + total}}</div>
          </div>
        </div>
        <!-- <div class="couponWrap"> -->
          <!-- <img v-if="(list.type == 6 || list.type == 7 || list.type == 8 || list.type == 9) && sliderData.length" @click="scrollToRight" class="rightImg" src="../assets/right.png" alt=""> -->
          <div class="couponBtn" v-if="(list.status == 3 || list.status == 2) && showorhiddenStatus == 1"><img @click="couponBtn" src="../assets/couponbtn.png" alt=""></div>
        <!-- </div> -->
        <!-- 转盘 -->
        <scrollpage v-if="list.disport && list.disport.length > 0" :disport='disport' class="content"></scrollpage>
        <div class="gift">
          <div class="giftBox" v-if="list.type != 11">
            <div class="giftBox-left"><img src="../assets/zengpin.jpg" alt=""></div>
            <div class="giftBox-right"><span>{{list.title}}#{{list.groupNum}}【{{list.standardName}}】</span></div>
          </div>
          <div class="giftBoxs" v-else>
            <div class="giftBox-right"><span>{{list.title}}</span></div>
            <div class="giftBox-right"><span>{{list.remark}}</span></div>
            <div class="giftBox-right" v-if="list.goods[0].type == 1"><span>规格: {{list.standardName}} ({{list.goods[0].standard.sheetsinput ? list.goods[0].standard.sheetsinput : list.goods[0].standard.sheets}}张 共{{list.goods[0].standard.totalcountinput ? list.goods[0].standard.totalcountinput : list.goods[0].standard.total}}张)</span></div>
            <div class="giftBox-right" v-if="list.goods[0].type == 2"><span>规格: {{list.standardName}} ({{list.goods[0].standard.sheetsinput ? list.goods[0].standard.sheetsinput : list.goods[0].standard.sheets}}张/包 共{{list.goods[0].standard.totalcountinput ? list.goods[0].standard.totalcountinput : list.goods[0].standard.total}}张)</span></div>
            <div class="giftBox-right" v-if="list.goods[0].type == 3"><span>规格: {{list.standardName}} ({{list.goods[0].standard.sheetsinput ? list.goods[0].standard.sheetsinput : list.goods[0].standard.sheets}}张/包 {{list.goods[0].standard.packageinput ? list.goods[0].standard.packageinput : list.goods[0].standard.packages}}包/盒 共{{list.goods[0].standard.totalcountinput ? list.goods[0].standard.totalcountinput : list.goods[0].standard.total}}张)</span></div>
            <div class="giftBox-right" v-if="list.goods[0].type == 4"><span>规格: {{list.standardName}} ({{list.goods[0].standard.sheetsinput ? list.goods[0].standard.sheetsinput : list.goods[0].standard.sheets}}张/包 {{list.goods[0].standard.packageinput ? list.goods[0].standard.packageinput : list.goods[0].standard.packages}}包/盒 {{list.goods[0].standard.boxinput ? list.goods[0].standard.boxinput : list.goods[0].standard.box}}盒/箱 {{list.goods[0].standard.totalcountinput ? list.goods[0].standard.totalcountinput : list.goods[0].standard.total}}张)</span></div>
            <div class="giftBox-right"><span>配送: {{list.expressTypeName}}</span></div>
          </div>
          
          <div class="gochickenList" v-show="list.isBindProduct ? !chickenShow : chickenShow" @click="chickenList"><img class="chickenImg" src="../assets/chickencard.png" alt=""></div>
          <!-- <div @click="goTurnpage" class="turnimgBox">
            <img class="turnImg" src="../assets/turntable.png" alt="">
          </div> -->
          <div v-if="list.type != 11" class="gift-text" @click="clickmask(list.type)">
            <span>{{list.typeName}}</span>
            <img style="width:.14rem;height:.14rem;margin-left:.03rem;" src="../assets/Vector.png" />
          </div>
        </div>
        <WechatService :serviceList="serviceData" />
        <!-- 每车好卡 -->
        <div class="thiscardWrap" v-if="imgList && imgList.length > 0">
          <div class="thiscardTop" @click="gogoodcards">
            <img class="thiscardTitle" src="../assets/thiscard.png" alt="">
            <div class="thiscardtopRight"><span >每日好卡</span><span style="margin-left:.02rem;">></span></div>
          </div>
          <div class="thiscardContent">
            <div class="thiscardImgs">
              <img class="cardsimgs" v-for="(item, index) in imgList" :key="index" :src="item.cover.thumbUrl" alt="" @click="goDetail(item)">
            </div>
            <!-- <img class="cardrightIcon" src="../assets/arrowright.png" alt=""> -->
          </div>
        </div>

        <!-- <div class="thiscardWrap" v-if="shareList.exist">
          <div class="thiscardTop" @click="goreward">
            <img class="thiscardTitle" src="../assets/thiscard.png" alt="">
            <div class="thiscardtopRight"><span >每日好卡</span><span style="margin-left:.02rem;">></span></div>
          </div>
          <div class="thiscardContent">
            <div class="thiscardImgs">
              <img class="cardsimgs" v-for="(item, index) in imgList" :key="index" :src="item.cover.thumbUrl" alt="" @click="goDetail(item)">
            </div>
          </div>
        </div> -->
        <!-- 下单赠抽奖/分享获奖等 -->
        <DeliverView :deliverList="deliverList" :shareList="shareList" :sharetoken="sharetoken" :saleList="saleList" :saletoken="saletoken" />
       

        <div class="buyrecord" v-if="buylist && buylist.length && list.type != 11">
          <div class="buyrecord-title">兑换记录</div>
          <!-- <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="loadMore"
          > -->
          <div class="infinite-scroll-content">
            <div class="buyrecord-list-content" v-for="(item, index) in buylist" :key="index">
              <div class="buyrecord-list-content-left">
                <div class="contentmsg">
                  <img :src="item.userInfo.avatar" alt="">
                  <div class="contentbox">
                    <div class="contentbox-name" v-if="item.userInfo.username">{{item.userInfo.username.substring(0, 1) + new Array(item.userInfo.username.length-1).join('*') + item.userInfo.username.substr(-1)}}</div>
                    <div class="contentbox-time">{{formatTimestamp(item.createTime)}}</div>
                  </div>
                </div>
              </div>
              <div class="buyrecord-list-content-right"><span>x </span>{{item.count}}</div>
            </div>
          </div>
          <!-- </van-list> -->
        </div>
        <div class="contenWrap" v-if="list.type == 2 || list.type == 3">
          <div class="listWrap" v-if="arrlist && arrlist.length > 18">
            <div class="listBox" @click="clicklistmarkshow(item, $event)" v-for="(item, index) in arrlist" :key="index" :class="{ actives: item.id == oprationRow.id }" :ref="`teamItem_${item.id}`">
              <div class="topRight">{{item.count}}</div>
              <div class="listBoxtop">
                <van-image
                  round
                  width=".36rem"
                  height=".36rem"
                  fit="cover"
                  :src="item.teamLogo"
                />
                <div class="contnet">
                  <p>{{item.title}}</p>
                  <div class="listTeam"><span>{{item.priceStr}}/</span>组</div>
                </div>
              </div>
              <div class="progress-box">
                <div class="progress-box-surplus" :style="`width:${(item.maxCount - (item.maxCount - item.sellCount)) /  item.maxCount * 100}%`"></div>
                <div class="progress-box-text">余 {{(item.maxCount - item.sellCount)  + '/' + item.maxCount}}</div>
              </div>
              <div class="markComboWrap">
                <div class="markCombo" v-for="(items, index) in item.combo" :key="index">{{items.title}}</div>
              </div>
              <div class="listMark" v-if="item.maxCount - item.sellCount == 0"><p>SOLD</p><p style="margin-top:.05rem">OUT</p></div>
            </div>
          </div>
          <div class="listWraps" v-else>
            <div class="listBox" @click="clicklistmarkshow(item, $event)" v-for="(item, index) in arrlist" :key="index" :class="{ actives: item.id == oprationRow.id }" :ref="`teamItem_${item.id}`">
              <div class="topRight">{{item.count}}</div>
              <div class="listBoxtop">
                <van-image
                  round
                  width=".36rem"
                  height=".36rem"
                  fit="cover"
                  :src="item.teamLogo"
                />
                <div class="contnet">
                  <p>{{item.title}}</p>
                  <div class="listTeam"><span>{{item.priceStr}}/</span>组</div>
                </div>
              </div>
              <div class="progress-box">
                <div class="progress-box-surplus" :style="`width:${(item.maxCount - (item.maxCount - item.sellCount)) /  item.maxCount * 100}%`"></div>
                <div class="progress-box-text">余 {{(item.maxCount - item.sellCount)  + '/' + item.maxCount}}</div>
              </div>
              <div class="markComboWrap">
                <div class="markCombo" v-for="(items, index) in item.combo" :key="index">{{items.title}}</div>
              </div>
              <div class="listMark" v-if="item.maxCount - item.sellCount == 0"><p>SOLD</p><p style="margin-top:.05rem">OUT</p></div>
            </div>
          </div>
          <!-- <div class="bottomWrap">
            <div class="bottomTitle">
              <div class="lefts">
                <p class="titleLeft">我的选队 ｜ </p>
                <p>将在所选球队的卡种中随机卡密</p>
              </div>
              <div class="count">共{{maxCount}}份</div>
            </div>
            <div class="bottomList">
              <div v-if="checkedList.length > 0" class="bottomList-list">
                <div class="bottomList-list-item" v-for="(item, index) in checkedList" :key="index">
                  <div class="left">
                    <div class="left-name">{{item.title}}</div>
                    <div class="left-cont">x{{item.count}}</div>
                  </div>
                  <div class="right">
                    <img src="../assets/closecircle.png" @click="delChecked(index)" alt="">
                  </div>
                </div>
              </div>
              <div class="notext" v-else>{{massage}}</div>
            </div>
          </div> -->
          <!-- <div class="bottomBox" v-if="show">
            <div class="bottomNum">购买数量</div>
            <van-stepper input-width="30" custom-class="btnTest" :allow-empty="false" v-model="oprationRow.count" :min="1" :max="maxnum"/>
            <div class="maxBtn" @click="maxbtn">MAX</div>
            <div class="botBtn" @click="pushCard">确认</div>
          </div>
          <div class="bottomBox" @click="sure" v-else>
            <div class="bottomNum">购买数量</div>
            <van-stepper input-width="30" disabled :min="0" v-model="defaultCont"/>
            <div class="maxBtn">MAX</div>
            <div class="botBtn">确认</div>
          </div> -->
        </div>
  <!-- v-if="list.type == 10" -->
        <div class="remain" v-if="list.type == 8 || list.type == 9">
          <div class="remainText">剩余组所有分组</div>
          <div class="remainLefttitle">
            <div class="remainLefttitleteam">队伍</div>
            <div class="remainLefttitlenum">数量</div>
            <div class="remainLefttitleprice">价格</div>
          </div>
          <div class="remainContentscroll">
            <div class="remainContent" v-for="(item, index) in remainList" :key="index">
              <div class="remainTeam">{{item.title}}</div>
              <div class="remainNum">{{item.maxCount - item.sellCount}}</div>
              <div class="remainPrice">{{item.priceStr}}</div>
            </div>
          </div>
          <div class="remainBottom">
            <div class="remainBottomboxbox">
              <div class="remainBottomnum">共{{maxSum}}份</div>
              <div class="remainBottomproice">每份 <span style="font-size:.1rem;">¥</span>{{priceStr}}</div>
            </div>
          </div>
        </div>
        
        <div class="text" v-if="list.type != 11">
          <img src="../assets/woring.png" alt="">
          您所选购的是由商家提供的随机精美卡片，您可根据精美卡片的价格自由选购一份或多份，同时商家会根据您的订单金额随机赠送产品系列卡密。鉴于卡片的随机性质，若您介意，请审慎选择购买。感谢您的理解与支持！
        </div>
        <div class="giftintroduce" v-if="list.type != 5 && list.type != 11">
          <div class="giftintroduce-title">
            <p></p>
            <div>赠品介绍</div>
          </div>
          <div class="giftintroduce-text">【系列名称】：{{list.title}}#{{list.groupNum}}【{{list.standardName}}】</div>
          <div class="giftintroduce-text">【活动说明】：{{list.remark}}</div>
          <div class="giftintroduce-text"  v-if="list.goods && list.goods.length > 0">【系列配置】：<div style="margin-left:.1rem;" v-for="(item, index) in list.goods" :key="index">{{index + 1}}. &nbsp;&nbsp;{{item.title}} &nbsp;&nbsp;{{item.standard.toConfigure}}</div>（以实际拆卡为准）</div>
          <div class="giftintroduce-text" v-else>【系列配置】：{{list.description}}（以实际拆卡为准）</div>
          <div class="giftintroduce-text" v-if="list.type == 5 || list.type == 11">【商品份数】：{{list.count}}份</div>
          <div class="giftintroduce-text" v-else>【赠品份数】：{{list.count}}份</div>
          <div class="giftintroduce-text" v-if="list.type == 1">【单价】：{{list.signPriceStr}}元</div>
          <div class="giftintroduce-text" v-else>【单价】：以实际购买队伍价格为准</div>
          <div class="giftintroduce-text">【备注】：{{list.showExpressName}}（若有疑问请联系客服）</div>
          <div class="giftintroduce-text" v-if="list.extra && list.type != 11">【拆卡时间】：{{list.extra.liveTime}}（具体拆卡公示时间请关注通知）</div>
          <div class="giftintroduce-text" v-if="list.type != 11">【拆卡方式】：组队成功后，将在平台进行公示</div>
          <div class="giftintroduce-text" v-if="list.type != 11">【获卡方式】：公示结束后24小时内，将在平台中上传拆卡报告，并在上传报告后3个工作日内向获得奖品的用户快递邮寄。（收件信息以用户支付页面预留信息为准，请准确填写）</div>
          <div class="giftintroduce-text" v-if="list.type != 11">【组队时限】：本组队时间为{{list.sellDays}}天，若{{list.sellDays}}天内未组队成功，所有款项将原路退回，除此情况外，均无法提供退款服务。</div>
        </div>
        <div class="giftintroduce" v-if="list.type == 11">
          <div class="giftintroduce-title">
            <p></p>
            <div>购买须知</div>
          </div>
          <div class="giftintroduce-text">1、本商品数量有限，遵循先到先得原则。</div>
          <div class="giftintroduce-text">2、商品均为未拆封正品。支持直接购买或特定兑换券兑换。若商品注明仅支持兑换券兑换，则仅可以使用指定兑换券兑换，不支持支付购买。</div>
          <div class="giftintroduce-text">3、请阅读商品关于“配送”的说明。邮寄包邮指支持顺丰包邮发出或自提。邮寄到付指支持顺丰到付发出或自提。由于商品特殊性质，适用特殊的退换货规则，不支持七天无理由退换货。</div>
          <div class="giftintroduce-text">4、本商品（包括但不限于卡片、卡包、卡盒、卡具等，以下简称“商品”）仅具有娱乐性质，不具备投资属性。请用户在购买前仔细阅读本平台协议及购买界面公示信息。本平台不鼓励任何投机行为，请广大用户合理规划参与购买的次数，理性消费。</div>
          <div class="giftintroduce-text">5、商品的生产商可能在生产过程中，存在小概率装箱失误或出厂瑕疵，该特殊情况商家无法控制，不承担相关责任。</div>
          <div class="giftintroduce-text">6、如果您是未满18周岁的未成年人，请在监护人的陪同、指导下购买本产品。已满18周岁的成年用户，因任何原因不具备完全民事能力的，参照适用本平台未成年人相关约定条款。平台根据《用户服务协议》中约定，在您购买支付之前可能要求您上传或验证相关个人信息以验证您的账号；如验证错误，平台有权冻结您账号的购物消费功能。我们将对您的信息加密保护，请您理解并支持。</div>
          <div class="giftintroduce-text">7、若您有任何疑问，请联系客服微信chaojicangku0001或supervault0002。</div>
        </div>
        <div class="giftintroduce" v-if="list.type == 5">
          <div class="giftintroduce-title">
            <p></p>
            <div>【赠品获得概率】</div>
          </div>
          <div class="giftText">100%</div>
        </div>
        <div class="giftintroduce" v-if="list.type != 5 && list.type != 11">
          <div class="giftintroduce-title">
            <p></p>
            <div>赠品获得概率</div>
          </div>
          <div class="giftText">f＝赠品获取概率</div>
          <div class="giftText">P＝赠品份数</div>
          <div class="giftText">Q＝“系列配置”中的卡片总张数</div>
          <div class="giftText">f＝1-［（P-1）/P］^Q</div>
        </div>
      </div>
    <!-- </div> -->
    <div class="markBox" v-if="maskVisible" ref="mask" @click="maskClick($event)">
      <div class="content" v-if="ids == 2">
        <div class="topfenge"></div>
        <div class="title">{{text.title}}</div>
        <pre class="texts">{{text.texts}}</pre>
      </div>
      <div class="content" v-if="ids == 3">
        <div class="topfenge"></div>
        <div class="title">{{textname.title}}</div>
        <pre class="texts">{{textname.texts}}</pre>
      </div>
      <div class="content" v-if="ids == 6">
        <div class="topfenge"></div>
        <div class="title">{{texttwo.title}}</div>
        <pre class="texts">{{texttwo.texts}}</pre>
      </div>
      <div class="content" v-if="ids == 7">
        <div class="topfenge"></div>
        <div class="title">{{textthree.title}}</div>
        <pre class="texts">{{textthree.texts}}</pre>
      </div>
      <div class="content" v-if="ids == 8">
        <div class="topfenge"></div>
        <div class="title">{{texteight.title}}</div>
        <pre class="texts" v-html="texteight.texts"></pre>
      </div>
      <div class="content" v-if="ids == 9">
        <div class="topfenge"></div>
        <div class="title">{{textnight.title}}</div>
        <pre class="texts" v-html="texteight.texts"></pre>
      </div>
    </div>
    <div class="chickenMarkwrap" v-if="chickenVisible" ref="chickenMark" @click="chickenClick($event)">
      <div class="chickenContent">
        <div class="topfenge"></div>
        <div class="chickenTitle"><span>卡密外附赠好礼</span><img @click="gorules" src="../assets/Vector.png" alt=""></div>
        <van-tabs v-model="activeName" @click="tabclick">
          <van-tab v-for="(item, index) in typelist" :key="index" :name="item.code" :title="item.value" />
          <!-- <van-tab name="2" title="鸡卡" /> -->
        </van-tabs>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMore"
          class="loadinglistWrap"
        >
        <div class="chickenListbox">
          <div class="listDetaillist" v-for="(item, index) in chickenLists" :key="index">
            <div class="chickenlist" v-if="item.type == 1">
                <van-image
                  class="leftImg"
                  fit="cover"
                  :src="item.chicken.avatar"
                  @click="coverImg(item.chicken.avatar)"
                />
              <div class="rightBox">
                <div class="rightTop">{{item.chicken.nameCn}}</div>
                <div class="righCenter">数量： <span style="font-size:.1rem;">x</span>{{item.count}}
                <div class="rightBottom">拼成获得</div>
              </div>
              </div>
            </div>
            <div class="contentBox" :class="getBgClass(item)" v-else>
              <div class="contentTop">
                <div class="contentTopleft">
                  <div class="leftTitle">{{item.coupon.couponName}}</div>
                  <div class="couponMoney" v-if="item.coupon.expireType != 0">{{item.coupon.startTime}} - {{item.coupon.endTime}}</div>
                  <div class="couponMoney" v-else>领取后{{item.coupon.cycleDay}}日内有效</div>
                  <div class="bottombox">
                    <div style="font-size:.11rem;padding:.05rem 0 .05rem .15rem;" v-if="item.coupon.limitUsers == 1">客户专享</div>
                    <div class="detailTitle" @click="flagTexts(item)">
                      <span>详情</span>
                      <van-icon style="width:.15rem;margin-left:.05rem;" :class="{detailTitleimg: isdetailTitleimg}"  name="arrow-down" />
                    </div>
                  </div>
                </div>
                <div class="rightImg">
                  <div class="text" v-if="item.coupon.amountSpent != -1 && item.coupon.couponType == 4">满{{item.coupon.amountSpent}}立享{{item.coupon.deductionAmount % 10 === 0 ? item.coupon.deductionAmount / 10 : item.coupon.deductionAmount}}折</div>
                  <div class="text" v-else-if="item.coupon.amountSpent != -1 && item.coupon.couponType != 4">满{{item.coupon.amountSpent}}立减{{item.coupon.deductionAmount}}</div>
                  <div class="text" v-else>无门槛券</div>
                  <div class="money" style="font-size:.12rem;" v-if="item.coupon.couponType == 4">{{item.coupon.deductionAmount % 10 === 0 ? item.coupon.deductionAmount / 10 : item.coupon.deductionAmount}}折</div>
                  <div class="money" style="font-size:.12rem;" v-else-if="item.coupon.couponType == 5">兑换券</div>
                  <div class="money" v-else>¥<span>{{item.coupon.deductionAmount}}</span></div>
                </div>
              </div>
            </div>
            <transition name="slide-fade" v-if="item.type != 1">
              <div class="detailDetail" v-if="item.flagText">
                <div v-html="item.coupon.description" style="white-space: normal; line-height: 1.5;"></div>
                <!-- <pre style="white-space: pre-line;word-break: break-all;word-wrap: break-word;">{{item.coupon.description.replace(/\\n/g, '\n')}}</pre> -->
              </div>
            </transition>
            <div class="cardDetailchicken" v-if="item.type == 1">
              <div>
                指定卡密：<span style="font-weight:600;color:#FFBA21">（ 数量：{{item.aliasList.total}} ）</span>
                <div v-for="(items, indexs) in item.aliasList.data" :key="indexs">{{(item.aliasList.pageNum - 1) * item.aliasList.pageSize + indexs + 1}}.{{items}}</div>
              </div>
            </div>
            <template v-else>
              <div class="cardDetail">
                <div>
                  指定卡密：<span style="font-weight:600;color:#FFBA21">（ 数量：{{item.aliasList.total}} ）</span>
                  <div v-for="(items, indexs) in item.aliasList.data" :key="indexs">{{(item.aliasList.pageNum - 1) * item.aliasList.pageSize + indexs + 1}}.{{items}}</div>
                </div>
              </div>
              <div class="btnBox" v-if="item.aliasList.pageNum > 1 ||  item.aliasList.pageNum < item.aliasList.total / item.aliasList.pageSize">
                <div class="btnBox-btn" :class="{ disabled: item.aliasList.pageNum <= 1 }" @click="changePage(item, 'prev', index)">上一页</div>
                <div class="btnBox-btn" :class="{ disabled: item.aliasList.pageNum >= item.aliasList.total / item.aliasList.pageSize }" @click="changePage(item, 'next', index)">下一页</div>
              </div>
            </template>
          </div>
        </div>
        </van-list>
      </div>
    </div>
    <div class="imgMark" v-if="imgMark" ref="imgMark" @click="coverImgclose($event)">
      <van-image
        class="imgImgmark"
        fit="cover"
        :src="avatarUrl"
      />
    </div>
    <van-popup
      v-model="contentMark"
      position="bottom"
      :style="{ overflow: 'auto' }"
      @close="closeContentmark"
      @opened="handlePopupOpened"
    >
    <div class="contentMark" v-if="contentMark" ref="contentMark" @click="clickContentmark($event)">
      <div class="markcontenWrap">
        <div class="marktop"></div>
        <div class="markbottomWrap">
          <div class="markbottomTitle">
            <div class="marklefts">
              <p class="marktitleLeft">我的选队 ｜ </p>
              <p>将在所选球队的卡种中随机卡密</p>
            </div>
            <div class="markcount">共{{maxCount}}份</div>
          </div>
          <div class="markbottomList">
            <div v-if="checkedList.length > 0" class="markbottomList-list" ref="scrollContainernum">
              <div class="markbottomList-list-item" v-for="(item, index) in checkedList" :key="index">
                <div class="markleft">
                  <div class="markleft-name">{{item.title}}</div>
                  <div class="markleft-cont">{{item.count}}组/{{item.count * item.payPrice / 100}}元</div>
                </div>
                <div class="markright">
                  <img src="../assets/closecircle.png" @click="delChecked(index)" alt="">
                </div>
              </div>
            </div>
            <div class="marknotext" v-else>{{massage}}</div>
          </div>
        </div>
        <div class="marklistWrap" ref="popupListContainer">
          <div class="marklistBox" @click="clicklist(item)" v-for="(item, index) in arrlist" :key="index" :class="{ actives: item.id == oprationRow.id }" :ref="`popupTeamItem_${item.id}`">
            <div class="marktopRight">{{item.count}}</div>
            <div class="marklistBoxtop">
              <van-image
                round
                width=".36rem"
                height=".36rem"
                fit="cover"
                :src="item.teamLogo"
              />
              <div class="markcontnet">
                <p>{{item.title}}</p>
                <div class="marklistTeam"><span>{{item.priceStr}}/</span>组</div>
              </div>
            </div>
            <div class="markprogress-box">
              <div class="markprogress-box-surplus" :style="`width:${(item.maxCount - (item.maxCount - item.sellCount)) /  item.maxCount * 100}%`"></div>
              <div class="markprogress-box-text">余 {{(item.maxCount - item.sellCount)  + '/' + item.maxCount}}</div>
            </div>
            <div class="markComboWrap">
              <div class="markCombo" v-for="(items, index) in item.combo" :key="index">{{items.title}}</div>
            </div>
            <div class="marklistMark" v-if="item.maxCount - item.sellCount == 0"><p>SOLD</p><p style="margin-top:.05rem">OUT</p></div>
          </div>
        </div>
        <div class="markCombolist">
          <div class="markCombolistcontent" v-for="(items, index) in this.combo" :key="index" @click="clickcombolist(items)" :class="{ markCombolistcontents: couponList == items.id }">{{items.title}}</div>
        </div>
        <div class="markbottomBox" v-if="show">
          <div class="markbottomNum">购买数量</div>
          <van-stepper input-width="30" custom-class="btnTest" @change="changNum" :allow-empty="false" v-model="oprationRow.count" :min="1" :max="maxnum"/>
          <div class="markmaxBtn" @click="maxbtn">MAX</div>
          <div class="markbotBtn" @click="pushCard">确认</div>
        </div>
        <div class="markbottomBox" @click="sure" v-else>
          <div class="markbottomNum">购买数量</div>
          <van-stepper input-width="30" disabled :min="0" v-model="defaultCont"/>
          <div class="markmaxBtn">MAX</div>
          <div class="markbotBtn">确认</div>
        </div>
      </div>
    </div>
    </van-popup>
    <div class="ruleWrap" v-if="ruleMark" ref="ruleMark" @click="ruleClose($event)">
      <div class="ruleContent">
        <div class="topfenge"></div>
        <div class="ruleTitle">卡密外附赠好礼活动规则</div>
        <div class="ruleBox">
          <div class="ruleList">
            <div class="ruleListtop">1、活动规则：</div>
            <div class="ruleListcontent">参与活动前，请您根据附赠好礼活动类型，仔细阅读下方活动说明；若您未理解活动说明，请勿参与！若有疑问请咨询客服：chaojicangku0001。当您参与本活动时，则视为理解活动规则与说明。</div>
            <div class="ruleListcontent">SuperVault（超级仓库）拥有活动最终解释权。</div>
          </div>
          <div class="ruleList">
            <div class="ruleListtop">2、活动说明：</div>
            <div class="ruleListcontent">您可在“卡密外附赠好礼”页面查看商家公示的指定卡密与优惠券的对应关系；附赠好礼类型如下：</div>
            <div class="ruleListcontent"><span style="border-bottom:.01rem solid #fff; font-weight:500;">立即获得指定优惠券</span>: 当您参与组队并随机到公示的指定卡密时，无论组队是否成功，均可立即获得系统自动发放的对应优惠券。</div>
            <div class="ruleListcontent"><span style="border-bottom:.01rem solid #fff; font-weight:500;">拼团成功后发放指定优惠券</span>: 当您参与组队并随机到公示的指定卡密时，在组队成功后，可获得系统自动发放的对应优惠券。</div>
            <div class="ruleListcontent"><span style="border-bottom:.01rem solid #fff; font-weight:500;">请注意，下列情况视为优惠券失效，不予发放/补发 </span>:</div>
            <div class="ruleListcontent">①本组队活动超时未售罄，组队失败；</div>
            <div class="ruleListcontent">②超过优惠券有效期限但未使用；</div>
            <div class="ruleListcontent">③可用券商品组队满员；</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import httpUrl from '../utils/config'
import prefix from '../utils/prefix'
import { isIos, isAndroid } from '../utils/device'
import scrollpage from './scrollpage'
import WechatService from './WechatService.vue'
import DeliverView from './DeliverView.vue'
import Chinaopen from './Chinaopen.vue'
export default {
  name: 'detailView',
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    scrollpage,
    WechatService,
    DeliverView,
    Chinaopen
  },
  data() {
    return {
      time: '',
      oldTimestamp: '',
      countTime: '',
      list: [],
      total:'',
      surplus:0,
      buylist:[],
      row: [],
      loading: false,
      pageNum: 1,
      pageSize: 100,
      totalnum: 0,
      maskVisible: false,
      current: 0,
      text:{
        title:'选队随机卡种 - 限时组队说明',
        texts: `1.玩家可在选队页面中选择自己心仪的球队参与活动，参与后将在所选球队的卡密中进行随机抽取。\n2. 常规球队涵盖该球队目前队名下的所有单人卡种以及同队的多人卡种；其他类型则包含老球队名下的卡种、不同队的多人卡种以及其他类型的卡密。\n3. 不同球队的份数和单价可能存在差异，请玩家理性进行选择。\n4. 若在产品中拆出未在卡密列表中且未在组队时说明归属的卡片，商家将通过第三方随机软件进行全员随机确定归属。\n5. 若买家获赠的系列卡密图文不符，以文字卡密为准。`
      },
      textname:{
        title:'选队随机球员 - 限时组队说明',
        texts: `1.玩家可在选队页面中选择自己心仪的球队参与活动，参与后将在所选球队的球员中进行随机抽取。\n2.常规球队涵盖该球队目前队名下的所有球员；其他类型则包含老球队名下的球员、不同队的多人卡以及其他类型的卡密。同队的多人卡可能归属于所属球队，也可能归属于其他类型，请以实际分组情况为准。\n3.不同球队的份数和单价可能存在差异，请玩家理性进行选择。\n4.若在产品中拆出未在卡密列表中且未在组队时说明归属的卡片，商家将通过第三方随机软件进行全员随机确定归属。\n5.若买家获赠的系列卡密图文不符，以文字卡密为准。`
      },
      texttwo:{
        title:'随机球员 - 限时拼团说明',
        texts: `1.参与活动后，玩家将获得系统随机抽取的球员，活动拆出的所有该球员的卡片都归该玩家所有。\n2.若在产品中拆出未在卡密列表中且未在组队时说明归属的卡片，商家将通过第三方随机软件进行全员随机确定归属。\n3. 若买家获赠的系列卡密图文不符，以文字卡密为准。`
      },
      textthree:{
        title:'随机卡种 - 限时拼团说明',
        texts: `1.参与活动后，玩家将获得系统随机抽取的卡密,卡密信息包含球员名、卡种、限编（若该栏内容为空白，则不带编）等信息，活动拆出的所有该卡密的卡片都归该玩家所有。\n2.若在产品中拆出未在卡密列表中且未在组队时说明归属的卡片，商家将通过第三方随机软件进行全员随机确定归属。\n3.若买家获赠的系列卡密图文不符，以文字卡密为准。`
      },
      texteight:{
        title:'剩余随机(选队-随机卡种) - 限时拼团说明',
        texts: `“剩余随机”的卡密列表由商家将商品所有未售出的分组合并而成，用户参与活动后将在合并后的分组（即“剩余组”）中进行随机抽取；您可在商品页面查看参与“剩余组”的卡密分组明细。\n   若您未理解活动玩法，请勿参与，或请联系客服chaojicangku0001。`
      },
      textnight:{
        title:'剩余随机(选队-随机球员) - 限时拼团说明',
        texts: `“剩余随机”的卡密列表由商家将商品所有未售出的分组合并而成，用户参与活动后将在合并后的分组（即“剩余组”）中进行随机抽取；您可在商品页面查看参与“剩余组”的卡密分组明细。\n   若您未理解活动玩法，请勿参与，或请联系客服chaojicangku0001。`
      },
      ids:0,
      arrlist:[],
      massage:'您还没有选队，请选择喜欢的球队及数量',
      show: false,
      oprationRow: {},
      checkedList: [],
      sum: 0,
      maxCount: 0,
      defaultCont: 0,
      maxnum: 0,
      sellTimeStr: '',
      banners: [],
      sliderData: [],
      chickenVisible: false,
      chickenLists: [],
      pages: {
        pageNum: 1,
        pageSize: 10
      },
      chickentotal: 0,
      finished: false,
      imgMark: false,
      avatarUrl: '',
      flagText: true,
      isdetailTitleimg: false,
      description: '',
      contentMark: false,

      ruleMark: false,
      // 滑动状态 判断左滑还是右滑
      status: false,
      // 判断是否触发滑动
      flag: false,
      // 开始位置
      startX: 0,
      // 结束位置
      endX: 0,
      activeName:'2',
      typelist: {},
      tabCode: 1,
      disport: [],
      height: 0,
      remainList: [],
      maxSum: 0,
      priceStr: 0,
      chickenShow: false,
      titlename: '',
      combo: [],
      showorhiddenStatus: 0,
      couponList: '',
      remainNum: 0,
      serviceData: [
        {
          name: '客服',
          avatar: 'https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/44/6233077a-7d7a-4df0-8aaf-d9301e501d45.png?height=3000&width=3000&size=1421',
          wechatId: 'chaojicangku0001',
          ercodeImg: "https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/245/832ea717-f493-4108-bc9b-1108ccb6f792.png?height=1296&width=950&size=119"
        },
        {
          name: '客服002',
          avatar: 'https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/51/685cf133-1750-4ebb-94fc-ed9b9f11f4ca.png?height=3000&width=3000&size=1411',
          wechatId: 'supervault0002',
          ercodeImg: "https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/75/1f6d670e-b47d-4892-8b35-b0c617ac6ebf.jpeg?height=1455&width=1074&size=212"
        },
        {
          name: '客服003',
          avatar: 'https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/200/f35c482d-712a-417f-9e88-aa7626afcc3e.png?height=3000&width=3000&size=1431',
          wechatId: 'chaojicangku003',
          ercodeImg: "https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/180/aeda9e83-ee74-47dc-8d99-b14a94170418.jpeg?height=1466&width=1074&size=354"
        }
      ],
      imgList: [],
      deliverList: [],
      shareList: {},
      sharetoken: '',
      imageUrl: 'https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/95/cbf76dfd-d961-417e-9b5e-51e78004462a.png?height=348&width=750&size=33',
      rightAngle: '1',
      saleList: {},
      saletoken: ''
    }
  },
  methods: {
    getBgClass(val) {
      // 根据条件值返回对应的类名
      if (val.coupon.couponType == 1 || val.coupon.couponType == 2 || val.coupon.couponType == 3) {
        return 'bg-style-1';
      } else if (val.coupon.couponType == 4) {
        return 'bg-style-2';
      } else if (val.coupon.couponType == 5) {
        return 'bg-style-3';
      } else {
        return 'bg-style-3'
      }
    },
    /**
     * 新增：将 CST (UTC+8) 时间字符串转换为 UTC 时间戳
     * @param {string} cstTimeStr - 格式如 "2024-05-20 23:59:59" 的时间字符串
     * @returns {number} - UTC 时间戳（毫秒）
     */
    convertCSTToUTC(cstTimeStr) {
      if (!cstTimeStr) return 0;

      // 1. 分割日期和时间
      const [datePart, timePart] = cstTimeStr.split(' ');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hours, minutes, seconds] = timePart.split(':').map(Number);

      // 2. 使用 Date.UTC() 方法创建时间戳
      //    这个方法会将传入的参数视为 UTC 时间
      //    注意：月份是 0-11，所以要减 1
      const utcTimestamp = Date.UTC(year, month - 1, day, hours, minutes, seconds);

      // 3. 由于服务器时间是 UTC+8，我们需要减去 8 小时以得到真正的 UTC 时间
      const eightHoursInMs = 8 * 60 * 60 * 1000;
      const trueUtcTimestamp = utcTimestamp - eightHoursInMs;

      return trueUtcTimestamp;
    },

    /**
     * 新增：统一管理倒计时定时器
     */
    // initTimer() {
    //   // 清除旧的定时器
    //   if (this.timer) {
    //     clearInterval(this.timer);
    //   }

    //   // 如果活动状态不是进行中或未开始，则不需要定时器
    //   if (![2, 3].includes(this.list.status)) {
    //     return;
    //   }
      
    //   // 每秒更新一次倒计时
    //   this.timer = setInterval(() => {
    //     const nowUTC = Date.now();

    //     // 更新【距结束】倒计时
    //     if (this.list.status === 3 && this.list.sellTime && this.list.sellDays) {
    //       const endTimeUTC = this.convertCSTToUTC(this.list.sellTime) + (this.list.sellDays * 24 * 60 * 60 * 1000);
    //       this.time = Math.max(endTimeUTC - nowUTC, 0);
    //     }

    //     // 更新【距开售】倒计时
    //     if (this.list.status === 2 && this.list.sellTime) {
    //       const sellTimeUTC = this.convertCSTToUTC(this.list.sellTime);
    //       this.sellTimeStr = Math.max(sellTimeUTC - nowUTC, 0);
    //     }

    //     // 如果两个倒计时都结束了，清除定时器
    //     if (this.time <= 0 && this.sellTimeStr <= 0) {
    //       clearInterval(this.timer);
    //       this.timer = null;
    //     }
    //   }, 1000);
    // },
    getlist() {
      let homeUrl = `${httpUrl}/teamup/detail?id=${this.$route.query.id}`
      this.$http.get(homeUrl).then((resp) => {
        this.list = resp.body.data
        if(this.list.disport) {
          this.list.disport.forEach(item=>{
            this.disport = item
          })
        }
        this.banners = resp.body.data.banners
        localStorage.setItem('banners', JSON.stringify(resp.body.data.banners))
        this.total = resp.body.data.count
        this.surplus = resp.body.data.soldCount
        if(this.list.status == 3 || this.list.status == 4 || this.list.status == 0) {
          clearInterval(this.timer)
        }
        const nowUTC = Date.now()

        // 更新【距结束】倒计时
        if (this.list.status === 3 && this.list.sellTime && this.list.sellDays) {
          const endTimeUTC = this.convertCSTToUTC(this.list.sellTime) + (this.list.sellDays * 24 * 60 * 60 * 1000);
          this.time = Math.max(endTimeUTC - nowUTC, 0);
        }

        // 更新【距开售】倒计时
        if (this.list.status === 2 && this.list.sellTime) {
          const sellTimeUTC = this.convertCSTToUTC(this.list.sellTime);
          this.sellTimeStr = Math.max(sellTimeUTC - nowUTC, 0);
        }
        console.log('111111111111')
        // const { sellDays, sellTime } = this.list
        // this.oldTimestamp = new Date(sellTime.replace(/-/g,'/')).setDate(new Date(sellTime.replace(/-/g,'/')).getDate() + sellDays)
        // let currentTimestamp = new Date().getTime()
        // this.time = this.oldTimestamp - currentTimestamp
        // // 开售时间 - 现在时间戳 = 距离开售时间
        // this.sellTimeStr = new Date(resp.body.data.sellTime.replace(/-/g,'/')).getTime() - new Date().getTime()
        // console.log('开售天数',new Date(resp.body.data.sellTime.replace(/-/g,'/')).getTime(), new Date().getTime(), this.sellTimeStr)
        if(resp.body.data.type == 7 || resp.body.data.type == 8 || resp.body.data.type == 9) {
          let homeUrlremain = `${httpUrl}/teamup/goods/snapshot?tid=${this.$route.query.id}`
          this.$http.get(homeUrlremain).then((response) => {
            this.remainList = response.data.data
            // response.data.data.forEach(item=> {
            //   this.maxSum += item.maxCount
            // })
          })
        }
        // 每车好卡
        let cardlist = `${httpUrl}/goodCard/thisGoodCards?tid=${this.list.id}`
        this.$http.get(cardlist).then((cardres) => {
          this.imgList = cardres.data.data
        })
      })
      let par = {
        tid: this.$route.query.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      let homeUrllist = `${httpUrl}/order/simple/list`
      this.$http.post(homeUrllist, par, {headers: { Authorization: this.$route.query.token }}).then((respo) => {
        this.buylist = respo.body.data.data
        this.totalnum = respo.body.data.total
      })
      let deliverUrl = `${httpUrl}/teamup/goods/orderMatchedDetail?tid=${this.$route.query.id}`
      this.$http.get(deliverUrl, {headers: { Authorization: this.$route.query.token }}).then((resdeliver) => {
        console.log(resdeliver)
        this.deliverList = resdeliver.data.data
      })
      let sharepar = {
        productId: this.$route.query.id
      }
      let shareUrl = `${httpUrl}/share/obtainShareDescriesById`
      this.$http.post(shareUrl, sharepar, {headers: { Authorization: this.$route.query.token }}).then((shareres) => {
        this.shareList = shareres.data.data
        this.sharetoken = this.$route.query.token
      })
      let saleUrl = `${httpUrl}/teamup/sale?tid=${this.$route.query.id}`
      this.$http.get(saleUrl, {headers: { Authorization: this.$route.query.token }}).then((saleres) => {
        this.saleList = saleres.data.data
        this.saletoken = this.$route.query.token
      })
    },
    formatTimestamp(dateTimeStamp) {
      var minute = 1000 * 60 //把分，时，天，周，半个月，一个月用毫秒表示
      var hour = minute * 60
      var day = hour * 24
      var week = day * 7
      var month = day * 30
      var now = new Date().getTime() //获取当前时间毫秒
      var dateTimeStampNow =new Date(dateTimeStamp.replace(/-/g,'/')).getTime() //根据传入时间去选择是否需要转化为时间戳
      var diffValue = now - dateTimeStampNow //时间差
      if (diffValue < 0) {
        return
      }
      var minC = diffValue / minute //计算时间差的分，时，天，周，月
      var hourC = diffValue / hour
      var dayC = diffValue / day
      var weekC = diffValue / week
      var monthC = diffValue / month
      var result = ''
      if (monthC >= 1 && parseInt(monthC) <= 3) {
        result = " " + parseInt(monthC) + "月前"
      } else if (weekC >= 1 && parseInt(weekC) <= 3) {
          result = " " + parseInt(weekC) + "周前"
      } else if (dayC >= 1 && parseInt(dayC) <= 6) {
          result = " " + parseInt(dayC) + "天前"
      } else if (hourC >= 1 && parseInt(hourC) <= 23) {
          result = " " + parseInt(hourC) + "小时前"
      } else if (minC >= 1 && parseInt(minC) <= 59) {
          result = " " + parseInt(minC) + "分钟前"
      } else if (diffValue >= 0 && parseInt(diffValue) <= minute) {
          result = "刚刚"
      } else {
        // dateTimeStamp.split('')[0] // 防止0.1+0.2 ！=0.3情况下造成的时间返回值错误以及 大于三个月情况下的显示 2018-10-20 10:20:30类型的使用
      }
      return result
    },
    clickImg(item, index) {
      ImagePreview({
        images: item.map(item => item.url),
        startPosition: index
      })
    },
    onChange(index) {
      this.current = index
    },
    clickmask(type) {
      this.ids = type
      this.maskVisible = true
      document.documentElement.style.overflowY = 'hidden'
    },
    clickcard() {
      let id = this.list.virtualGoods.id
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "cardClicked",
          data: {
            id: id
          }
        })
      } else if(isAndroid()) {
        let par = {
          id: id
        }
        window.android.cardClicked(JSON.stringify(par))
      } else {
        console.log('other')
      }
    },
    maskClick(event) {
      if (event.target === this.$refs.mask) {
        // 执行遮罩层隐藏的逻辑
        this.maskVisible = false
        document.documentElement.style.overflowY = 'auto'
      }
    },
    getgoodslist() {
      let homeUrlgoods = `${httpUrl}/teamup/goods/detail?id=${this.$route.query.id}`
      this.$http.get(homeUrlgoods).then((response) => {
        if (response.body.status == 200) {
          let arr = []
          this.arrlist = response.data.data
          this.arrlist.forEach(item=>{
            this.priceStr = item.priceStr
            this.maxSum = item.maxCount
            item.combo.forEach(items=>{
              arr.push({
                titles: item.title,
                ...items
              })
            })
          })
          this.sliderData = arr
        }
      })
    },
    // 选中详情列表里的某一个队伍
    clicklistmarkshow(row) {
      this.clicklist(row)
      if( row.id == this.oprationRow.id ) {
        this.contentMark = true
        document.documentElement.style.overflowY = 'hidden'
      }
    },
    // 点击当前队伍（其中一个）
    clicklist(row){
      this.remainNum = row.maxCount - row.sellCount
      this.combo = row.combo
      if (this.oprationRow.id == row.id){
        this.oprationRow = {}
        this.show = false
        this.combo = []
        if(isIos()) {
          if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iOSCall) {
             window.webkit.messageHandlers.iOSCall.postMessage({
              action: "uncheck",
              data: {
                tgid: 0
              }
            })
          } else {
            console.log("非iOS环境，跳过iOS调用")
          }
        } else if(isAndroid()) {
          if(window.android && typeof window.android.uncheck === 'function') {
            let par = {
              tgid: 0
            }
            window.android.uncheck(JSON.stringify(par))
          } else {
            console.log("非android环境，跳过iOS调用")
          }
        } else {
          console.log('其他')
        }
      } else {
        if ((row.maxCount - row.sellCount) > 0) {
          if(isIos()) {
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iOSCall) {
              window.webkit.messageHandlers.iOSCall.postMessage({
                action: "selectedTeam",
                data: {
                  tgid: row.id
                }
              })
            } else {
              console.log('000000')
            }
          } else if(isAndroid()) {
            if (window.android && typeof window.android.uncheck === 'function') {
              let params = {
                tgid: row.id
              }
              window.android.selectedTeam(JSON.stringify(params))
            } else {
              console.log('11111')
            }
          } else {
            console.log('其他')
          }
          this.maxnum = row.maxCount - row.sellCount
          this.oprationRow = JSON.parse(JSON.stringify(row))
          this.oprationRow.payPrice = this.oprationRow.price
          let index = this.checkedList.findIndex(item => item.id == this.oprationRow.id)
          if (index == -1) {
            this.$set(this.oprationRow, 'count', 1)
          } else {
            this.$set(this.oprationRow, 'count', this.checkedList[index].count)
          }
          this.show = true
        }
      }
    },
    handlePopupOpened() {
      // 等待DOM更新
      this.$nextTick(() => {
        // 获取弹窗中对应选中项的DOM元素
        const targetItem = this.$refs[`popupTeamItem_${this.oprationRow.id}`]?.[0];
        const container = this.$refs.popupListContainer;
        
        if (targetItem && container) {
          // 滚动到选中项位置
          container.scrollTop = targetItem.offsetTop - 140; // 减去100px使选中项居中显示
          
          // 可以添加一个高亮动画效果
          targetItem.classList.add('highlight-animation');
          setTimeout(() => {
            targetItem.classList.remove('highlight-animation');
          }, 1000);
        }
      });
    },
    // 点套餐
     clickcombolist(row) {
      if(this.remainNum < row.express) {
        this.$toast('套餐的组数超出了剩余的组数')
      } else {
        if(row.id == this.couponList) {
          this.couponList = ''
          this.oprationRow.count = 1
          this.oprationRow.payPrice = this.oprationRow.price
        } else {
          this.couponList = row.id
          this.oprationRow.count = row.express
          this.oprationRow.payPrice = row.rule
        }
      }
      
    },
    // 点击加加减减的按钮
    changNum(value) {
      let current = {}
      if (value >= this.combo[0].express) {
        this.combo.forEach((item, index) => {
          if (value >= item.express) {
            if (this.combo[index + 1]) {
              if (value < this.combo[index + 1].express) current = item
            } else {
              current = item
            }
          }
        })
      }
      if (current && current.id) {
        this.couponList = current.id
        this.oprationRow.payPrice = current.rule
      } else {
        this.couponList = ''
        this.oprationRow.payPrice = this.oprationRow.price
      }
    },
    // 点确定按钮
    pushCard () {
      let index = this.checkedList.findIndex(item => item.id == this.oprationRow.id)
      if( index == -1) {
        this.checkedList.push(this.oprationRow)
      } else {
        this.checkedList[index] = this.oprationRow
      }
      this.show = false
      this.oprationRow = {}
      this.sum = eval(this.checkedList.map(item => item.payPrice * item.count).join('+'))
      this.maxCount = eval(this.checkedList.map(item => item.count).join('+'))
      // 点击确定按钮添加的直接在最后一个展示
      this.$nextTick(() => {
        this.$refs.scrollContainernum.scrollLeft = this.$refs.scrollContainernum.scrollWidth
      })
      if(this.couponList) {
        let data = {
          num: this.maxCount,
          sum: this.sum,
          arrlist: this.checkedList
        }
        console.log('有值点确定', data)
        this.couponList = ''
        this.combo = []
        if(isIos()) {
          window.webkit.messageHandlers.iOSCall.postMessage({
            action: "updateTotalAmount",
            data: {
              num: this.maxCount,
              sum: this.sum,
              arrlist: this.checkedList
            }
          })
        } else if(isAndroid()) {
          let pars = {
            num: this.maxCount,
            sum: this.sum,
            arrlist: this.checkedList
          }
          window.android.updateTotalAmount(JSON.stringify(pars))
        } else {
          console.log('other')
        }
      } else {
        let data = {
          num: this.maxCount,
          sum: this.sum,
          arrlist: this.checkedList
        }
        console.log('没值点确定', data)
        this.combo = []
        if(isIos()) {
          window.webkit.messageHandlers.iOSCall.postMessage({
            action: "updateTotalAmount",
            data: {
              num: this.maxCount,
              sum: this.sum,
              arrlist: this.checkedList
            }
          })
        } else if(isAndroid()) {
          let pars = {
            num: this.maxCount,
            sum: this.sum,
            arrlist: this.checkedList
          }
          window.android.updateTotalAmount(JSON.stringify(pars))
        } else {
          console.log('other')
        }
      }
      
    },
    // 点击删除按钮
    delChecked (index) {
      this.checkedList.splice(index, 1)
      this.sum = eval(this.checkedList.map(item => item.payPrice*item.count).join('+')) || 0
      this.maxCount = eval(this.checkedList.map(item => item.count).join('+')) || 0
      // let data = {
      //   num: this.maxCount,
      //   sum: this.sum,
      //   arrlist: this.checkedList
      // }
      // console.log(data)
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "updateTotalAmount",
          data: {
            num: this.maxCount,
            sum: this.sum,
            arrlist: this.checkedList
          }
        })
      } else if(isAndroid()) {
        let pars = {
          num: this.maxCount,
          sum: this.sum,
          arrlist: this.checkedList
        }
        window.android.updateTotalAmount(JSON.stringify(pars))
      } else {
        console.log('other')
      }
    },
    sure() {
      this.$toast('请先选择队伍')
    },
    maxbtn() {
      this.oprationRow.count = this.oprationRow.maxCount - this.oprationRow.sellCount
    },
    groupTeamdetail() {
      if(this.list.type == 6 || this.list.type == 7 || this.list.type == 8 || this.list.type == 9 || this.list.type == 11) {
        let sum = eval(this.arrlist.map(item => item.price*1).join('+'))
        let par = {
          num: 1,
          arrlist: this.arrlist,
          sum: sum,
          tid: this.list.id,
          payType: this.list.payType
        }
        return par
      } else {
        if(this.checkedList.length >= 1) {
          let par = {
            num: this.maxCount,
            sum: this.sum,
            arrlist: this.checkedList
          }
          return par
        } else {
          let par = {
            num: this.oprationRow.count,
            arrlist: [this.oprationRow]
          }
          return par
        }    
      }
    },
    // 倒计时等于0的时候触发
    handleFinish() {
      this.timer = setInterval(() => {
        this.getlist()
      }, 2000)
    },
    couponBtn() {
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "receiveCoupon",
          data: {
            id: this.list.id
          }
        })
      } else if(isAndroid()) {
        console.log('isAndroid')
        let parsm = {
          id: this.list.id
        }
        window.android.receiveCoupon(JSON.stringify(parsm))
      } else {
        console.log('other')
      }
    },
    tabclick(index) {
      this.tabCode = index
      this.loadMore()
    },
    chickenList() {
      this.chickenVisible = true
      document.documentElement.style.overflowY = 'hidden'
      this.pages.pageNum = 1
      this.chickenLists = []
      this.chickentotal = 0
      this.finished = false
      let homeUrlgoods = `${httpUrl}/teamup/bind/type/exists?tid=${this.list.id}`
      this.$http.get(homeUrlgoods, {headers: { Authorization: this.$route.query.token }}).then((response) => {
        this.typelist = response.data.data.raw
      })
      this.loadMore()
    },
    loadMore() {
      let par = {
        tid: this.list.id,
        pageNum: this.pages.pageNum,
        pageSize: this.pages.pageSize,
        type: this.activeName
      }
      let homeUrlgoods = `${httpUrl}/teamup/bind/product/list`
      this.loading = true
      this.$http.post(homeUrlgoods, par, {headers: { Authorization: this.$route.query.token }}).then((response) => {
        this.chickentotal = response.data.data.total
        response.data.data.data.forEach(item => { item.flagText = false })
        if (this.pages.pageNum == 1) this.chickenLists = response.data.data.data
        else this.chickenLists = [...this.chickenLists, ...response.data.data.data]
        if (this.pages.pageNum >= Math.ceil(this.chickentotal / this.pages.pageSize)) {
          this.finished = true
        } else {
          this.pages.pageNum++
        }
        this.loading = false
      })
    },
    chickenClick(event) {
      if (event.target === this.$refs.chickenMark) {
        // 执行遮罩层隐藏的逻辑
        this.chickenVisible = false
        document.documentElement.style.overflowY = 'auto'
      }
    },
    flagTexts(row) {
      row.flagText = !row.flagText
      this.isdetailTitleimg = !this.isdetailTitleimg
    },
    coverImg(img) {
      this.avatarUrl = img
      this.imgMark = true
      document.documentElement.style.overflowY = 'hidden'
    },
    coverImgclose(event) {
      if (event.target === this.$refs.imgMark) {
        this.imgMark = false
        // document.documentElement.style.overflowY = 'auto'
      }
    },
    closeContentmark() {
      this.contentMark = false
      document.documentElement.style.overflowY = 'auto'
      this.oprationRow = {}
      this.combo = []
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "uncheck",
          data: {
            tgid: 0
          }
        })
      } else if(isAndroid()) {
        let par = {
          tgid: 0
        }
        window.android.uncheck(JSON.stringify(par))
      } else {
        console.log('其他')
      }
    },
    clickContentmark(event){
      if (event.target === this.$refs.contentMark) {
        this.contentMark = false
        document.documentElement.style.overflowY = 'auto'
        this.oprationRow = {}
        this.combo = []
        // this.show = false
        if(isIos()) {
          window.webkit.messageHandlers.iOSCall.postMessage({
            action: "uncheck",
            data: {
              tgid: 0
            }
          })
        } else if(isAndroid()) {
          let par = {
            tgid: 0
          }
          window.android.uncheck(JSON.stringify(par))
        } else {
          console.log('其他')
        }
      }
    },
    // 点击滑动到最后一个
    scrollToRight() {
      const container = this.$refs.scrollContainer
      if (container) {
        container.scrollLeft = container.scrollWidth
      }
    },
    // 点击卡密发放规则
    gorules() {
      this.ruleMark = true
      document.documentElement.style.overflowY = 'hidden'
    },
    ruleClose(event) {
      if (event.target === this.$refs.ruleMark) {
        // 执行遮罩层隐藏的逻辑
        this.ruleMark = false
        // document.documentElement.style.overflowY = 'auto'
      }
    },
    goTurnpage() {
       
    },
    statusBarHeight(event) { 
      // 处理接收到的数据
      console.log('Received message:', event)
      this.height = event
    },
    clickback() {
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "backButtonClicked",
          data: {
          }
        })
      } else if(isAndroid()) {
        console.log('isAndroid')
        window.android.backButtonClicked()
      } else {
        console.log('other')
      }
    },
    clickmore() {
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "shareButtonClicked",
          data: {
          }
        })
      } else if(isAndroid()) {
        console.log('isAndroid')
        window.android.shareButtonClicked()
      } else {
        console.log('other')
      }
    },
    changePage(row, type, index) {
      const data = row.aliasList
      let totalPage = data.total / data.pageSize
      if (type == 'next') {
        if (data.pageNum < totalPage) data.pageNum++
        else return
      } else if (type == 'prev') {
        if (data.pageNum > 1) data.pageNum--
        else return
      }
      this.getItemList(row, index)
    },
    getItemList (row, index) {
      let par = {
        productId: row.productId,
        type: row.type,
        pageSize: row.aliasList.pageSize,
        pageNum: row.aliasList.pageNum,
        tid: this.list.id
      }
      let homeUrlprevious = `${httpUrl}/teamup/bind/product/alias/list`
      this.loading = true
      this.$http.post(homeUrlprevious, par).then((res) => {
        this.$set(this.chickenLists[index], 'aliasList', res.data.data.aliasList)
      })
    },
    copyText() {
      const textToCopy = "supervault0002"
      // 创建临时input元素
      const input = document.createElement("input")
      input.value = textToCopy
      document.body.appendChild(input)
      // 选中并复制文本
      input.select()
      document.execCommand("copy")
      // 移除临时元素
      document.body.removeChild(input)
      // 提示用户复制成功
      this.$toast('复制成功')
    },
    // 点击每车好卡
    goDetail(row) {
      const url = `${prefix}/blindboxs/DailygoodcardView?id=${row.id}&thisgoodcard=${1}&goodCardType=${1}`
      const encodedUrl = encodeURIComponent(url)
      console.log('encodedUrl', encodedUrl)
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "router",
          data: {
            url: `supervault://web?url=${encodedUrl}`
          }
        })
      } else if(isAndroid()) {
        let par = {
          url: `supervault://web?url=${encodedUrl}`
        }
        window.android.router(JSON.stringify(par))
      }
    },
    // 点击每日好卡
    gogoodcards() {
      if(isIos()) {
        window.webkit.messageHandlers.iOSCall.postMessage({
          action: "router",
          data: {
            url: `supervault://goodCard`
          }
        })
      } else if(isAndroid()) {
        let par = {
          url: `supervault://goodcCard`
        }
        window.android.router(JSON.stringify(par))
      }
    }
    // updateStatus() {
    //   let homeUrlgoods = `${httpUrl}/teamup/goods/detail?id=${this.$route.query.id}`
    //   this.$http.get(homeUrlgoods).then((response) => {
    //     if (response.body.status == 200) {
    //       this.lists = response.body.data
    //       this.checkedList.forEach((item, index) => {
    //         this.lists.forEach(row => {
    //           if (item.number == row.number) {
    //             if (row.sellCount){
    //               this.checkedList.splice(index, 1)
    //               this.arrlist.splice(index, 1)
    //             }
    //           }
    //         })
    //       })
    //       if (this.checkedList.length > 0) {
    //         this.sum = eval(this.checkedList.map(item => item.price).join('+'))
    //       } else {
    //         this.sum = 0
    //       }
    //     }
    //     console.log('4444', this.checkedList.length, this.sum, this.checkedList, [this.oprationRow])
    //     if(isIos()) {
    //       window.webkit.messageHandlers.iOSCall.postMessage({
    //         action: "updateTotalAmount",
    //         data: {
    //           num: this.checkedList.length,
    //           sum: this.sum,
    //         }
    //       })
    //     } else if(isAndroid()) {
    //       let parsa = {
    //         num: this.checkedList.length,
    //         sum: this.sum
    //       }
    //       window.android.updateTotalAmount(JSON.stringify(parsa))
    //     } else {
    //       console.log('other')
    //     }
    //   })
    //   console.log('点击购买后返回至详情页，准备请求接口')
    //   let homeUrl = `${httpUrl}/teamup/detail?id=${this.$route.query.id}`
    //   this.$http.get(homeUrl).then((resp) => {
    //     console.log('点击购买后返回至详情页接口请求成功', resp)
    //     this.list = resp.body.data
    //     this.total = resp.body.data.count
    //     this.surplus = resp.body.data.soldCount
    //     this.banners = resp.body.data.banners
    //     if(this.list.status == 3 || this.list.status == 4) {
    //       clearInterval(this.timer)
    //     }
    //     const { sellDays, sellTime } = this.list
    //     this.oldTimestamp = new Date(sellTime.replace(/-/g,'/')).setDate(new Date(sellTime.replace(/-/g,'/')).getDate() + sellDays)
    //     let currentTimestamp = new Date().getTime()
    //     this.time = this.oldTimestamp - currentTimestamp
    //     // 开售时间 - 现在时间 = 距离开售时间
    //     this.sellTimeStr = new Date(resp.body.data.sellTime.replace(/-/g,'/')).getTime() - new Date().getTime()
    //     // console.log('开售天数', new Date(resp.body.data.sellTime.replace(/-/g,'/')).getTime(), new Date().getTime(), this.sellTimeStr)
    //   })
    //   let par = {
    //     tid: this.$route.query.id,
    //     pageNum: this.pageNum,
    //     pageSize: this.pageSize
    //   }
    //   let homeUrllist = `${httpUrl}/order/simple/list`
    //   this.$http.post(homeUrllist, par).then((respo) => {
    //     this.buylist = respo.body.data.data
    //     this.totalnum = respo.body.data.total
    //   })
    // },
  },
  created() {
    if(isIos()) {
      console.log('ios')
      let getidpar = {
        productId: this.$route.query.id
      }
      // 是否展示领券入口
      let homeUrlgetid = `${httpUrl}/coupon/areThereAnyDiscountCouponsAvailable`
      this.$http.post(homeUrlgetid, getidpar, {headers: { Authorization: this.$route.query.token, deviceType: '1' }}).then((response) => {
        this.showorhiddenStatus = response.data.data.status
      })
      window.webkit.messageHandlers.iOSCall.postMessage({
        action: "navigationStyle",
        data: {
          style: 3
        }
      })
    } else if(isAndroid()) {
      console.log('isAndroid')
      let getidpar = {
        productId: this.$route.query.id
      }
      let homeUrlgetid = `${httpUrl}/coupon/areThereAnyDiscountCouponsAvailable`
      this.$http.post(homeUrlgetid, getidpar, {headers: { Authorization: this.$route.query.token, deviceType: '2' }}).then((response) => {
        this.showorhiddenStatus = response.data.data.status
      })
      let parsm = {
        style: 3
      }
      window.android.navigationStyle(JSON.stringify(parsm))
    } else {
      console.log('other')
    }
  },
  mounted() {
    document.title="超级仓库"
    this.getlist()
    this.getgoodslist()
    window.groupTeamdetail = this.groupTeamdetail
    window.statusBarHeight = this.statusBarHeight
  },
}
</script>
<style scoped lang="scss">
[v-cloak] {
  display: none
}
.my-swipe .van-swipe-item .van-image {
  width: 100%;
  height: 3rem;
  flex-shrink: 0;
}
.banner{
  width: 100%;
  height: 3rem;
  flex-shrink: 0;
}
.shareWrap{
  background: url('https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/200/73057b8b-5827-449b-8997-eabf64bb9977.png?height=188&width=724&size=79') no-repeat;
  background-size: 100% 100%;
  height: .72rem;
  width: 2.8rem;
  position: absolute;
  top: .8rem;
  right: 0;
  z-index:1;
}
.shareText{
  font-size: 0.13rem;
  line-height: 0.78rem;
  margin-left: .3rem;
  font-weight: 500;
}
.infinite-scroll-content{
  display: flex;
  flex-wrap:wrap;
  align-items: center;
}
.custom-indicator {
  position: absolute;
  right: .1rem;
  bottom: .1rem;
  padding: .04rem .07rem;
  font-size: .13rem;
  background: rgba(0, 0, 0, .5);
  border-radius:.1rem;
  color:#fff;
}
.detailWrap {
  width:100%;
  height:100%;
  &-cards{
    display: flex;
    flex-wrap: wrap;
    gap: .18rem;
    &-item{
       div{
        .transi {
          transition: transform .50s;
          transform: rotateY(360deg);
        }
      }
      img{
        width:.38rem;
        height:.38rem;
      }
    }
  }
  .card-box{
    display: flex;
    justify-content: space-between;
    width:100%;
    height:.92rem;
    background: url('../assets/price.png') no-repeat;
    background-size:100% 100%;
    padding:.1rem 0 .09rem .26rem;
    &-left{
      width:50%;
      height: .5rem;
      margin-top:.07rem;
      &-title{
        font-size:.13rem;
        color:#fff;
        display: flex;
        align-items: center;
      }
      &-money{
        span{
          font-size:.13rem;
        }
        font-size:.2rem;
        color:#FFBA21;
        padding-top:.06rem;
      }
    }
    &-right{
      font-size:.13rem;
      color:#fff;
      text-align: left;
      width:50%;
      margin-left:.78rem;
      margin-top:.1rem;
      .flexs{
        display: flex;
        align-items: center;
        width:100%;
        margin-top:.07rem;
      }
      .van-count-down{
        font-size:.13rem;
        color:#fff;
        font-weight:500
      }
      .colon {
        display: inline-block;
        margin: 0 .02rem;
        color: #fff;
      }
      .block {
        display: inline-block;
        width: .21rem;
        height:.21rem;
        line-height: .23rem;
        color: #000;
        font-size: .12rem;
        text-align: center;
        background-color: #FFBA21;
        border-radius:.04rem;
      }
    }
  }
  .card-wrap{
    width:100%;
    background: url('../assets/back.png') no-repeat;
    background-size:100% 100%;
    padding:.2rem .16rem;
    border-radius: .16rem .16rem 0 0;
    margin-top: -.15rem;
    .jianWrap{
      margin-bottom:.15rem;
      display: flex;
      overflow: hidden;
      overflow-x: scroll;
      white-space: nowrap;
      scrollbar-width: none;
      z-index: 1;
      .couponList{
        font-size:.1rem;
        color:#FFBA21;
        padding:.05rem .1rem;
        margin-left:.05rem;
        background:rgba(255, 186, 33, 0.12);
        border-radius:.06rem;
        text-align: center;
      }
    }
    &-box{
      width:100%;
      background: rgba(255, 255, 255, 0.08);
      padding:.12rem;
      border-radius:.16rem;
      .card-number{
        font-size:.11rem;
        color:#fff;
      }
      .progress-box{
        width:100%;
        height:.06rem;
        background:#ccc;
        position: relative;
        margin-top:.05rem;
        border-radius: .03rem;
        &-surplus{
          height:.06rem;
          background: linear-gradient(81deg, #FFBA21 35.51%, #FDD988 40.85%, #FFBA21 46.58%, #FFBA21 55.97%, #FDD988 61.48%, #FFBA21 66.8%);
          position: absolute;
          top:0;
          left:0;
          border-radius: .03rem;
        }
        &-surpluss{
          height:.06rem;
          position: absolute;
          top:0;
          left:0;
          border-radius: .03rem;
          background: linear-gradient(245.47deg, #BF0BFF -35.01%, #3E45FF 122.41%);
        }
      }
      .onsale{
        width:100%;
        display: flex;
        justify-content: space-between;
        font-size:.1rem;
        margin-top:.05rem;
        color:#fff;
      }
    }
    // .couponBtn{
    //   width:100%;
    //   display: flex;
    //   justify-content: end;
    //   margin-top:.1rem;
    //   img{
    //     width:.59rem;
    //     height:.24rem;
    //   }
    // }
    // .couponWrap{
    //   width:100%;
    //   display: flex;
    //   justify-content: flex-end;
    //   align-items: center;
    //   position: relative;
    //   margin-top: .1rem;
    //   .rightImg{
    //     width:.16rem;
    //     height:.16rem;
    //     margin-top:.1rem;
    //     margin-left:.05rem;
    //   }
      .couponBtn{
        width:100%;
        display: flex;
        justify-content: flex-end;
        z-index:1;
        margin-top:.1rem;
        img{
          width:.59rem;
          height:.24rem;
        }
      }
    // }
    .gift{
      width:100%;
      background:rgba(255, 255, 255, 0.08);
      border-radius: .16rem;
      margin-top: .12rem;
      position: relative;
      padding: .12rem;
      .texts{
        position: absolute;
        top:.25rem;
        left:.1rem;
        font-size:.15rem;
        color:#fff;
        padding-bottom:.08rem;
        width:100%;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
      }
      .giftBox{
        display: flex;
        align-items: center;
        &-left{
          width:.35rem;
          background:#FFBA21;
          border-radius: .04rem;
          font-size:.15rem;
          font-family: YouSheBiaoTiHei;
          color:#060518;
          text-align: center;
          line-height:.24rem;
          margin-top:.08rem;
        }
        &-right{
          display: block;
          word-break: break-all;
          width:3.1rem;
          font-size: .12rem;
          color:#fff;
          padding:.08rem 0 0 .12rem;
          line-height: .18rem;
        }
      }
      .gochickenList{
        width:100%;
        margin-top:.1rem;
      }
      .btn-box {
        border: 1px solid red;
        position: fixed;
        top: 40%;
        padding: 10px 20px;
        transition: all 0.5s;
      }
      .turnimgBox{
        width:.6rem;
        height:.6rem;
        position: fixed;
        top:5rem;
        right:0;
        z-index:1;
        padding: 10px 20px;
        transition: all 0.5s;
        .turnImg{
          width:100%;
          height:100%;
        }
      }
      // .content{
      //   height: 200vh
      // }
      // .icon-chat{
      //   width: 2rem;
      //   height: 1.9rem;
      //   background: url('http://pfpdwbdfy.bkt.clouddn.com/image/test/fixedIconTranstion/wechat.png') no-repeat;
      //   background-size: 2rem 1.9rem;
      // }
      &-text{
        position: absolute;
        top:0;
        right:0;
        padding:.02rem .11rem;
        height:.16rem;
        font-size:.11rem;
        color:#fff;
        background: linear-gradient(90deg, rgba(40, 30, 91, 0.00) 0%, #452DBC 61.5%, #452DBC 100%);
        border-top-right-radius: .11rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .contenWrap{
      width: 100%;
      background: rgba(255, 255, 255, 0.08);
      border-radius: .16rem;
      // border-top-right-radius: .16rem;
      // border-bottom-left-radius: .4rem;
      // border-bottom-right-radius: .4rem;
      margin-top: .1rem;
      // padding-bottom:.7rem;
      // position: relative;
      // .bottomWrap{
      //   width:100%;
      //   padding:.15rem .15rem 0 .15rem;
      //   .bottomTitle{
      //     width:100%;
      //     display: flex;
      //     align-items: center;
      //     color:rgba(255, 255, 255, 0.60);
      //     font-size:.11rem;
      //     display: flex;
      //     align-items: center;
      //     justify-content: space-between;
      //     .lefts{
      //       display: flex;
      //       align-items: center;
      //       .titleLeft{
      //         font-size:.15rem;
      //         color:#fff;
      //       }
      //     }
      //     .count{
      //       color:#FFBA21;
      //       font-size:.11rem;
      //     }
      //   }
      //   .bottomList{
      //     font-size:.12rem;
      //     color:#ccc;
      //     text-align: center;
      //     &-list{
      //       display: flex;
      //       align-items: center;
      //       margin:.1rem 0 .05rem 0;
      //       overflow-x: auto;
      //       &-item{
      //         height:.4rem;
      //         border:.01rem solid transparent;
      //         border-radius: .07rem;
      //         background-clip: padding-box, border-box;
      //         background-origin: padding-box, border-box;
      //         background-image: linear-gradient(to right, #3A4055, #3A4055), linear-gradient(to right, #dab3e8, #5c60e2);
      //         display: flex;
      //         align-items: center;
      //         justify-content: space-around;
      //         padding:.05rem;
      //         margin-right:.1rem;
      //         flex-shrink: 0;
      //         .left{
      //           font-size:.13rem;
      //           border-right:.01rem solid rgba(255, 255, 255, 0.30);
      //           padding-right:.03rem;
      //           &-name{
      //             color:#fff;
      //             padding-bottom:.04rem;
      //           }
      //           &-cont{
      //             font-size:.13rem;
      //             color:orange;
      //           }
      //         }
      //         .right{
      //           img{
      //             width:.24rem;
      //             height:.24rem;
      //             margin-left:.05rem;
      //           }
      //         }
      //       }
      //     }
      //     .notext{
      //       width:100%;
      //       height:.39rem;
      //       padding:.05rem 0;
      //       text-align:center;
      //       line-height:.3rem;
      //       font-size:.13rem;
      //       color:rgba(255, 255, 255, 0.60);
      //       background:rgba(255, 255, 255, 0.08);
      //       border-radius: .07rem;
      //       margin:.1rem 0 .05rem 0;
      //     }
      //   }
      // }
      .listWrap{
        width:100%;
        height:3rem;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow: hidden;
        overflow-y: scroll;
        scrollbar-width: none;
        gap:.06rem;
        padding:.1rem .07rem;
        .listBox{
          width:1.05rem;
          height:1.2rem;
          border-radius: .07rem;
          color:#fff;
          padding:.1rem .06rem;
          margin-top:.05rem;
          display: flex;
          flex-direction: column;
          position: relative;
          border: 0.5px solid rgba(255, 231, 85, 0.10);
          background: rgba(255, 255, 255, 0.06);
          justify-content: space-around;
          .listBoxtop{
            display: flex;
            align-items: center;
            .contnet{
              width:.5rem;
              padding-left:.05rem;
              p {
                width:.5rem;
                font-size:.13rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .listTeam{
                font-size:.11rem;
                margin-top:.05rem;
                width:.6rem;
                span{
                  font-size:.11rem;
                }
              }
            }
          }
          .progress-box{
            width:100%;
            height:.11rem;
            background:#3A4055;
            position: relative;
            margin-top:.1rem;
            border-radius: .15rem;
            &-surplus{
              height:.11rem;
              background: orange;
              position: absolute;
              top:0;
              left:0;
              border-radius: .15rem;
            }
            &-text{
              font-size:.08rem;
              color:#fff;
              text-align: center;
              position: relative;
              line-height: 0.11rem;
              // position: absolute;
              // top:.01rem;
              // left:30%;
            }
          }
          .jindu{
            margin-top:.05rem;
            font-size: .1rem;
            color:#fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .markComboWrap{
              width:100%;
              display: flex;
              font-size:.1rem;
              flex-wrap: wrap;
              color: #FFBA21;
              .markCombo{
                padding:.05rem 0 0 0;
              }
            }
          .listMark{
            width:1.04rem;
            height:1.19rem;
            border-radius: .07rem;
            border: 0.5px solid rgba(255, 231, 85, 0.10);
            background: rgba(255, 255, 255, 0.06);
            color:#fff;
            position: absolute;
            top:0;
            left:0;
            background: rgba(0,0,0, .8);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size:.14rem;
          }
        }
        .actives{
          background: linear-gradient(245deg, #BF0BFF -35.01%, #3E45FF 122.41%);
        }
      }
      .listWraps{
        width:100%;
        // height:3rem;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow: hidden;
        overflow-y: scroll;
        scrollbar-width: none;
        gap:.08rem;
        padding:.1rem .07rem;
        .listBox{
          width:1.04rem;
          height:.76rem;
          border-radius: .07rem;
          color:#fff;
          padding:.1rem .06rem;
          margin-top:.05rem;
          display: flex;
          flex-direction: column;
          position: relative;
          border: 0.5px solid rgba(255, 231, 85, 0.10);
          background: rgba(255, 255, 255, 0.06);
          .listBoxtop{
            display: flex;
            align-items: center;
            .contnet{
              width:.5rem;
              padding-left:.05rem;
              p {
                width:.5rem;
                font-size:.13rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .listTeam{
                font-size:.11rem;
                margin-top:.05rem;
                width:.6rem;
                span{
                  font-size:.11rem;
                }
              }
            }
          }
          .progress-box{
            width:100%;
            height:.11rem;
            background:#3A4055;
            position: relative;
            margin-top:.1rem;
            border-radius: .15rem;
            &-surplus{
              height:.11rem;
              background: orange;
              position: absolute;
              top:0;
              left:0;
              border-radius: .15rem;
            }
            &-text{
              font-size:.08rem;
              color:#fff;
              text-align: center;
              line-height: 0.11rem;
              // position: absolute;
              // top:.01rem;
              // left:30%;
            }
          }
          .jindu{
            margin-top:.05rem;
            font-size: .1rem;
            color:#fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .listMark{
            width:1.07rem;
            height:.75rem;
            border-radius: .07rem;
            border: 0.5px solid rgba(255, 231, 85, 0.10);
            background: rgba(255, 255, 255, 0.06);
            color:#fff;
            position: absolute;
            top:0;
            left:0;
            background: rgba(0,0,0, .8);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size:.14rem;
          }
        }
        .actives{
          background: linear-gradient(245deg, #BF0BFF -35.01%, #3E45FF 122.41%);
        }
      }
      .bottomBox{
        width:100%;
        height:.6rem;
        border-radius: .43rem;
        background: #000;
        opacity: 1;
        padding:0 .14rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top:.14rem;
        position: absolute;
        bottom:0;
        left:0;
        .bottomNum{
          font-size:.15rem;
          color:#fff;
          font-weight: 500;
        }
        .maopacityxBtn{
          width:.5rem;
          height:.3rem;
          border-radius: .42rem;
          border:.01rem solid rgba(255, 231, 85, 0.10);
          font-size: .13rem;
          color:#FFBA21;
          text-align: center;
          line-height: .3rem;
        }
        .botBtn{
          width: .65rem;
          height: .3rem;
          border-radius: 42px;
          background: linear-gradient(245deg, #BF0BFF -35.01%, #3E45FF 122.41%);
          font-size:.13rem;
          color:#fff;
          text-align: center;
          line-height:.32rem;
        }
        .maxBtn{
          width:.5rem;
          height:.3rem;
          line-height: .28rem;
          font-size:.13rem;
          color:#FFBA21;
          text-align: center;
          border:.01rem solid #FFBA21;
          border-radius: .42rem;
        }
        .van-stepper{
          width: 1.04rem;
          height: .34rem;
          padding: .01rem .04rem .01rem .04rem;
          border-radius: .43rem;
          background: rgba(255, 255, 255, 0.06);
          border:.01rem solid rgba(255, 231, 85, 0.10);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      } 
    }
    .remain{
      margin: 0.1rem 0;
      height: 4rem;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.08);
      border-radius: .15rem;
      .remainText{
        width:100%;
        color:#fff;
        padding:.15rem .15rem .1rem .15rem;
        font-size: .14rem;
        font-weight:900;
        background: rgba(255, 255, 255, 0.08);
        text-align: center;
      }
      .remainLefttitle{
        width:100%;
        height:.42rem;
        line-height: .42rem;
        display: flex;
        align-items: center;
        font-size:.13rem;
        color:#fff;
        font-weight: 900;
        justify-content: space-around;
        background: rgba(255, 255, 255, 0.08);
        .remainLefttitleteam{
          width:1.5rem;
        }
        .remainLefttitlenum{
          width:.5rem;
          text-align: center;
        }
      }
      .remainContentscroll{
        height:2.8rem;
        overflow: hidden;
        overflow-y: scroll;
        scrollbar-width: none;
        .remainContent{
          width:100%;
          height:.42rem;
          line-height: .42rem;
          display: flex;
          align-items: center;
          font-size:.13rem;
          color:#fff;
          justify-content: space-around;
          .remainTeam{
            width:1.5rem;
          }
          .remainNum{
            width:.5rem;
            text-align: center;
          }
        }
        .remainContent:nth-child(odd) {
          background-color: rgba(255, 255, 255, 0.04);
        }
      }
      .remainBottom{
        width:100%;
        height:.4rem;
        line-height: .4rem;
        background: rgba(255, 255, 255, 0.08);
        .remainBottomboxbox{
          display: flex;
          align-items: center;
          font-size:.14rem;
          color:#FFBA21;
          font-weight: 500;
          .remainBottomnum{
            width:50%;
            text-align: center;
          }
          .remainBottomproice{
            width: 50%;
            text-align: center;
          }

        }
      }
    }
    .sumBox{
      width:1rem;
      height:.5rem;
      background:red;
      color:#fff;
    }
    .thiscardWrap{
      width:3.43rem;
      height:1.24rem;
      background: rgba(255, 255, 255, 0.08);
      border-radius: .16rem;
      padding:.12rem;
      box-sizing: border-box;
      margin-top:10px;
      .thiscardTop{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .thiscardTitle{
          height:.2rem;
        }
        .thiscardtopRight{
          font-size:.11rem;
          color: rgba(255, 255, 255, 1);
        }
      }
      .thiscardContent{
        width:3.19rem;
        height:.76rem;
        // background: linear-gradient(to right, rgba(0, 92, 229, 1), rgba(169, 92, 129, 1), rgba(255, 190, 92, 1)); /* 从左到右的渐变 */
        border-radius: .06rem;
        margin-top:10px;
        display: flex;
        align-items: center;
        padding:8px;
        box-sizing: border-box;
        background: url('../assets/backcard.png') no-repeat;
        background-size: 100% 100%;
        .thiscardImgs{
          width:2.77rem;
          display: flex;
          flex: 1;
          flex-wrap: nowrap;
          align-items: center;
          overflow: hidden;
          overflow-x: scroll;
          scrollbar-width: none; /* Firefox 隐藏滚动条 */
          -ms-overflow-style: none;
          .cardsimgs{
            display: block;
            width:.6rem;
            height:.6rem;
            border-radius: .07rem;
            border: 0.01rem solid rgb(255 255 255 / 23%);
            margin:0 .02rem;
            flex-shrink: 0;
          }
        }
        .cardrightIcon{
          width:.18rem;
          display: block;
          margin-left:.1rem;
        }
      }
    }
    
    .buyrecord{
      width:100%;
      padding:.12rem 0 .12rem .12rem;
      border-radius: .16rem;
      background:  rgba(255, 255, 255, 0.08);
      // height: 1.53rem;
      // overflow-y: scroll;
      margin-top:.12rem;
      // scrollbar-width: none;
      &-title{
        font-size: 0.13rem;
        color:#fff;
      }
      &-list{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        &-content{
          display: flex;
          align-items: center;
          justify-content: space-between;
          width:50%;
          padding-right:.25rem;
          &-left{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .contentmsg{
              display: flex;
              margin-top:.1rem;
              img{
                width:.33rem;
                height:.33rem;
                border-radius: 50%;
              }
              .contentbox{
                font-size: 0.1rem;
                color:#fff;
                padding-left:.05rem;
                margin-top:.05rem;
                &-time{
                  padding-top:.05rem;
                  color:rgba(255, 255, 255, 0.60);
                }
              }
            }
          }
          &-right{
            font-size:.13rem;
            color:#FFBA21;
          }
        }
      }
    }
    .text{
      margin-top:.12rem;
      width:100%;
      line-height:.18rem;
      color:#fff;
      font-size:.13rem;
      text-align: justify;
      img{
        width:.14rem;
        height:.14rem;
      }
    }
    .giftintroduce{
      width:100%;
      margin-top:.16rem;
      margin-bottom:.1rem;
      &-title{
        display: flex;
        align-items: center;
        font-size:.15rem;
        color:#fff;
        p{
          width:.02rem;
          height:.13rem;
          background: #FFBA21;
          margin-right:.1rem;
        }
      }
      &-text{
        font-size:.15rem;
        color:#fff;
        margin-top:.15rem;
        line-height:.22rem;
        text-align: justify;
      }
    }
  }
  .card-number{
    font-size:.1rem;
    color:#fff;
  }
  .bottom{
    width:100%;
    height:.7rem;
    background:#0f1025de;
    position: fixed;
    bottom:0;
    left:0;
    border-top-left-radius: .15rem;
    border-top-right-radius: .15rem;
    display: flex;
    .moneybtn{
      width:1.3rem;
      height:.3rem;
      background: linear-gradient(to right, rgb(13, 125, 210), rgb(123, 168, 215));
      font-size:.14rem;
      color:#fff;
      line-height: .3rem;
      text-align: center;
      border-radius: .2rem;
      margin-left:35%;
      margin-top:.2rem;
    }
    .btns{
      width:1rem;
      height:.4rem;
      background:skyblue;
      color:#fff;
      font-size:.14rem;
      text-align: center;
      line-height: .4rem;
      border-radius: .05rem;
    }
  }
  .markBox{
    width:100%;
    height:100%;
    background: rgba(6, 5, 24, 0.40);
    backdrop-filter: blur(10px);
    position: fixed;
    top:0;
    left:0;
    z-index:1;
    .content{
      width:100%;
      position: absolute;
      bottom:0;
      left:0;
      height: 3.75rem;
      background: url('../assets/backtwo.png') no-repeat;
      background-size:100% 100%;
      padding:.16rem;
      font-size:.13rem;
      color:#fff;
      animation: slideInFromBottom 0.3s ease;
      animation-fill-mode: forwards;
      opacity: 0;
      transform: translateY(100%);
      @keyframes slideInFromBottom {
        0% {
          opacity: 0;
          transform: translateY(100%);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .topfenge{
        width:.4rem;
        height:.05rem;
        background:#fff;
        border-radius: .05rem;
        margin-left: 1.5rem;
        margin-bottom: .3rem;
        margin-top: .1rem;
      }
      .title{
        text-align: center;
        font-size:.17rem;
      }
      .texts{
        width:100%;
        height: 2.8rem;
        overflow-y: scroll;
        scrollbar-width: none;
        white-space: pre-wrap;
        text-align: justify;
        line-height:.24rem;
        // text-indent: .25rem;
      }
    }
  }
  .chickenMarkwrap{
    width:100%;
    height:100vh;
    background:rgba(0, 0, 0, .4);
    position: fixed;
    top:0;
    left:0;
    z-index:3;
    .chickenContent{
      width: 100%;
      height:80%;
      padding:.1rem;
      box-sizing: border-box;
      background: url('../assets/back.png') no-repeat;
      background-size: 100% 100%;
      border-top-right-radius: .4rem;
      border-top-left-radius: .4rem;
      position: fixed;
      bottom:0;
      left:0;
      // overflow: hidden;
      // overflow-y: scroll;
      // scrollbar-width: none;
      .topfenge{
        width:.4rem;
        height:.05rem;
        background:#fff;
        border-radius: .05rem;
        margin-left: 1.5rem;
        margin-top: .1rem;
      }
      .chickenTitle{
        font-size:.17rem;
        color:#fff;
        margin:.2rem .2rem 0 .2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width:.2rem;
          height:.2rem;
          margin-left:.05rem;
        }
      }
      .loadinglistWrap{
        height:5.2rem;
        overflow: hidden;
        overflow-y: scroll;
        scrollbar-width: none;
        margin-top:.15rem;
        padding-bottom:1rem;
        .chickenListbox{
          .listDetaillist{
            width: 100%;
            padding:.15rem;
            background:rgba(255, 255, 255, 0.08);
            border-radius: .16rem;
            margin-top:.1rem;
            .chickenlist{
              display: flex;
              .leftImg{
                width:.76rem;
                height:.76rem;
                border-radius: .07rem;
              }
              .rightBox{
                margin-left:.1rem;
                color:#fff;
                .rightTop{
                  font-size:.13rem;
                }
                .righCenter{
                  font-size:.11rem;
                  color:rgba(255, 255, 255, 1);
                  margin-top:.1rem;
                }
                .rightBottom{
                  font-size:.11rem;
                  color:rgba(255, 255, 255, 0.6);
                  margin-top:.1rem;
                }
              }
            }
            .slide-fade-enter-active {
              transition: all .2s ease;
            }
            .slide-fade-leave-active {
              transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
            }
            .slide-fade-enter, .slide-fade-leave-to {
              transform: translateY(-10px);
              opacity: 0;
            }
            .detailDetail{
              width:100%;
              padding: .4rem 0.15rem .05rem .15rem;
              font-size:.12rem;
              color:#fff;
              background: rgba(255, 255, 255, 0.02);
              line-height: .22rem;
              border-radius: .04rem;
              margin-top:-.4rem;
            }
            .bg-style-1 {
              background:url('../assets/couponpink.png') no-repeat;
              background-size: 100% 100%;
            }

            .bg-style-2 {
              background:url('../assets/couponred.png') no-repeat;
              background-size: 100% 100%;
            }

            .bg-style-3 {
              background:url('../assets/coupon.png') no-repeat;
              background-size: 100% 100%;
            }
            .contentBox{
              height:1rem;
              display: flex;
              flex-direction: column;
              position: relative;
              z-index:1;
              .contentTop{
                display: flex;
                position: relative;
                .contentTopleft{
                  display: flex;
                  flex-direction: column;
                  .new{
                    width:.42rem;
                    height:.18rem;
                    position: absolute;
                    top:.03rem;
                    left:0;
                    background: linear-gradient(237.56deg, #005CE6 -21.06%, #A95C81 55.65%, #FFBE5C 137.61%),linear-gradient(0deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
                    color:#fff;
                    font-size:.11rem;
                    text-align: center;
                    line-height: .18rem;
                    border-top-left-radius: .06rem;
                    border-bottom-right-radius: .06rem;
                  }
                  .leftTitle{
                    font-size:.13rem;
                    font-weight: 500;
                    margin-top:.3rem;
                    padding-left:.15rem;
                  }
                  .couponMoney{
                    font-size:.11rem;
                    padding:.06rem 0  0 .15rem;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 170px;
                  }
                  .bottombox{
                    display: flex;
                    align-items: center;
                    margin-top:.08rem;
                    font-size:.11rem;
                    font-weight: 500;
                    .detailTitle{
                      padding-left:.15rem;
                      .detailTitleimg{
                        // width:.1rem;
                        // margin-left:.05rem;
                        transform: rotate(180deg);
                      }
                    }
                  }
                }
                .rightImg{
                  color:#FFBA21;
                  position: absolute;
                  top:.35rem;
                  right:.35rem;
                  text-align: center;
                  width:.9rem;
                  .text{
                    font-size:.12rem;
                  }
                  .money{
                    font-size:.1rem;
                    font-weight: 500;
                    padding-top:.07rem;
                    span{
                      font-size:.18rem;
                    }
                  }

                }
              }
            }
            .cardDetail{
              width:100%;
              padding:.1rem;
              font-size:.11rem;
              background:rgba(17, 24, 48, 0.3);
              color:rgba(255, 255, 255, 1);
              margin-top:.1rem;
              border-radius: .05rem;
              line-height:.16rem;
              height: 1rem;
              overflow: hidden;
              overflow-y: scroll;
              scrollbar-width: none;
            }
            .btnBox{
              width:100%;
              display: flex;
              align-items: center;
              justify-content: space-around;
              margin-top:.15rem;
              &-btn{
                background: linear-gradient(90deg, rgb(80 86 206) 20%, rgb(176 75 212) 100%);
                border: .01rem solid rgba(154, 92, 169, 1);
                font-size:.12rem;
                color:#fff;
                text-align: center;
                line-height: .27rem;
                border-radius: .1rem;
                padding:0 .15rem;
                &.disabled{
                  background: #ccc;
                  border-color: #ccc;
                }
              }
            }
            .cardDetailchicken{
              width:100%;
              padding:.1rem;
              font-size:.11rem;
              background:rgba(17, 24, 48, 0.3);
              color:rgba(255, 255, 255, 1);
              margin-top:.1rem;
              border-radius: .05rem;
              line-height:.16rem;
            }
          }
        }
      }
    }
  }
  .giftText{
    font-size:.14rem;
    color:#fff;
    margin:.1rem 0 0 .1rem;
  }
  .imgMark{
    width:100%;
    height:100vh;
    background:rgba(0, 0, 0, .9);
    display: grid;
    place-items: center; /* 水平和垂直居中 */
    position: fixed;
    top:0;
    left:0;
    z-index:3;
    .imgImgmark{
      max-width: 100%;
      height:auto;
    }
  }
  .contentMark{
    // width:100%;
    // height:100%;
    // background: rgba(0,0,0,.9);
    // position: fixed;
    // top:0;
    // left:0;
    .markcontenWrap{
      width: 100%;
      height:5.7rem;
      background:url('../assets/back.png') no-repeat;
      background-size: 100% 100%;
      border-top-left-radius: .4rem;
      border-top-right-radius: .4rem;
      position: fixed;
      bottom: 0;
      left:0;
      transform: translateY(100%);
      animation: slide-up .3s forwards;
      @keyframes slide-up {
        to {
          transform: translateY(0);
        }
      }
      .markbottomWrap{
        width:100%;
        padding:.3rem .15rem .15rem .15rem;
        .markbottomTitle{
          width:100%;
          display: flex;
          align-items: center;
          color:rgba(255, 255, 255, 0.60);
          font-size:.11rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .marklefts{
            display: flex;
            align-items: center;
            .marktitleLeft{
              font-size:.15rem;
              color:#fff;
            }
          }
          .markcount{
            color:#FFBA21;
            font-size:.11rem;
          }
        }
        .markbottomList{
          font-size:.12rem;
          color:#ccc;
          text-align: center;
          &-list{
            display: flex;
            align-items: center;
            margin:.1rem 0 .05rem 0;
            overflow-x: auto;
            &-item{
              height:.4rem;
              border:.01rem solid transparent;
              border-radius: .07rem;
              background-clip: padding-box, border-box;
              background-origin: padding-box, border-box;
              background-image: linear-gradient(to right, #3A4055, #3A4055), linear-gradient(to right, #dab3e8, #5c60e2);
              display: flex;
              align-items: center;
              justify-content: space-around;
              padding:.05rem;
              margin-right:.1rem;
              flex-shrink: 0;
              .markleft{
                font-size:.13rem;
                border-right:.01rem solid rgba(255, 255, 255, 0.30);
                padding-right:.03rem;
                &-name{
                  color:#fff;
                  padding-bottom:.04rem;
                }
                &-cont{
                  font-size:.11rem;
                  color:orange;
                }
              }
              .markright{
                img{
                  width:.24rem;
                  height:.24rem;
                  margin-left:.05rem;
                }
              }
            }
          }
          .marknotext{
            width:100%;
            height:.39rem;
            padding:.05rem 0;
            text-align:center;
            line-height:.3rem;
            font-size:.13rem;
            color:rgba(255, 255, 255, 0.60);
            background:rgba(255, 255, 255, 0.08);
            border-radius: .07rem;
            margin:.1rem 0 .05rem 0;
          }
        }
      }
      .marklistWrap{
        width:100%;
        height:3.3rem;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow: hidden;
        overflow-y: scroll;
        scrollbar-width: none;
        gap:.08rem;
        padding-left: .1rem;
          .marklistBox{
            width:1.13rem;
            height:1.2rem;
            border-radius: .07rem;
            color:#fff;
            padding:.1rem .06rem;
            margin-top:.05rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            position: relative;
            border: 0.5px solid rgba(255, 231, 85, 0.10);
            background: rgba(255, 255, 255, 0.06);
            .markComboWrap{
              width:100%;
              display: flex;
              font-size:.1rem;
              flex-wrap: wrap;
              color: #FFBA21;
              .markCombo{
                padding:.05rem 0 0 0;
              }
            }
            .marklistBoxtop{
              display: flex;
              align-items: center;
              .markcontnet{
                width:.5rem;
                padding-left:.05rem;
                p {
                  width:.5rem;
                  font-size:.13rem;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .marklistTeam{
                  font-size:.11rem;
                  margin-top:.05rem;
                  width:.6rem;
                  span{
                    font-size:.11rem;
                  }
                }
              }                
            }
            .markprogress-box{
              width:100%;
              height:.11rem;
              background:#3A4055;
              position: relative;
              margin-top:.1rem;
              border-radius: .15rem;
              &-surplus{
                height:.11rem;
                background: orange;
                position: absolute;
                top:0;
                left:0;
                border-radius: .15rem;
              }
              &-text{
                font-size:.08rem;
                color:#fff;
                text-align: center;
                height:0.11rem;
                line-height:0.11rem;
                position: relative;
              }
            }
            .markjindu{
              margin-top:.05rem;
              font-size: .1rem;
              color:#fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .marklistMark{
              width:1.12rem;
              height:1.19rem;
              border-radius: .07rem;
              border: 0.5px solid rgba(255, 231, 85, 0.10);
              background: rgba(255, 255, 255, 0.06);
              color:#fff;
              position: absolute;
              top:0;
              left:0;
              background: rgba(0,0,0, .8);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-size:.14rem;
            }
          }
          .actives{
            background: linear-gradient(245deg, #BF0BFF -35.01%, #3E45FF 122.41%);
          }
      }
        // .marklistWraps{
        //   width:100%;
        //   // height:3rem;
        //   display: flex;
        //   flex-wrap: wrap;
        //   align-content: flex-start;
        //   overflow: hidden;
        //   overflow-y: scroll;
        //   scrollbar-width: none;
        //   gap:.08rem;
        //   padding:.1rem .07rem;
        //   .marklistBox{
        //     width:1.04rem;
        //     height:.76rem;
        //     border-radius: .07rem;
        //     color:#fff;
        //     padding:.1rem .06rem;
        //     margin-top:.05rem;
        //     display: flex;
        //     flex-direction: column;
        //     position: relative;
        //     border: 0.5px solid rgba(255, 231, 85, 0.10);
        //     background: rgba(255, 255, 255, 0.06);
        //     .marklistBoxtop{
        //       display: flex;
        //       align-items: center;
        //       .markcontnet{
        //         width:.5rem;
        //         padding-left:.05rem;
        //         p {
        //           width:.5rem;
        //           font-size:.13rem;
        //           white-space: nowrap;
        //           overflow: hidden;
        //           text-overflow: ellipsis;
        //         }
        //         .marklistTeam{
        //           font-size:.11rem;
        //           margin-top:.05rem;
        //           width:.6rem;
        //           span{
        //             font-size:.11rem;
        //           }
        //         }
        //       }
        //     }
        //     .markprogress-box{
        //       width:100%;
        //       height:.11rem;
        //       background:#3A4055;
        //       position: relative;
        //       margin-top:.1rem;
        //       border-radius: .15rem;
        //       &-surplus{
        //         height:.093rem;
        //         background: orange;
        //         position: absolute;
        //         top:0;
        //         left:0;
        //         border-radius: .15rem;
        //       }
        //       &-text{
        //         font-size:.08rem;
        //         color:#fff;
        //         text-align: center;
        //         // position: absolute;
        //         // top:.01rem;
        //         // left:30%;
        //       }
        //     }
        //     .markjindu{
        //       margin-top:.05rem;
        //       font-size: .1rem;
        //       color:#fff;
        //       display: flex;
        //       align-items: center;
        //       justify-content: center;
        //     }
        //     .marklistMark{
        //       width:1.07rem;
        //       height:.75rem;
        //       border-radius: .07rem;
        //       border: 0.5px solid rgba(255, 231, 85, 0.10);
        //       background: rgba(255, 255, 255, 0.06);
        //       color:#fff;
        //       position: absolute;
        //       top:0;
        //       left:0;
        //       background: rgba(0,0,0, .8);
        //       display: flex;
        //       flex-direction: column;
        //       align-items: center;
        //       justify-content: center;
        //       font-size:.14rem;
        //     }
        //   }
        //   .actives{
        //     background: linear-gradient(245deg, #BF0BFF -35.01%, #3E45FF 122.41%);
        //   }
        // }
        .markCombolist{
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          font-size: .1rem;
          overflow: hidden;
          overflow-x: scroll;
          margin-top: .15rem;
          .markCombolistcontent {
            border: .01rem solid #5e51b5;
            padding: .1rem;
            border-radius: .2rem;
            color: #fff;
          }
          .markCombolistcontents {
            border: .01rem solid #5e51b5;
            padding: .1rem;
            border-radius: .2rem;
            color: #fff;
            background: #5e51b5;
          }
        }
        .markbottomBox{
          width:3.43rem;
          height:.6rem;
          border-radius: .43rem;
          background: #9387873b;
          opacity: 1;
          padding:0 .14rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          bottom:.15rem;
          left:.15rem;
          .markbottomNum{
            font-size:.15rem;
            color:#fff;
            font-weight: 500;
          }
          .markmaopacityxBtn{
            width:.5rem;
            height:.3rem;
            border-radius: .42rem;
            border:.01rem solid rgba(255, 231, 85, 0.10);
            font-size: .13rem;
            color:#FFBA21;
            text-align: center;
            line-height: .3rem;
          }
          .markbotBtn{
            width: .65rem;
            height: .3rem;
            border-radius: 42px;
            background: linear-gradient(245deg, #BF0BFF -35.01%, #3E45FF 122.41%);
            font-size:.13rem;
            color:#fff;
            text-align: center;
            line-height:.32rem;
          }
          .markmaxBtn{
            width:.5rem;
            height:.3rem;
            line-height: .28rem;
            font-size:.13rem;
            color:#FFBA21;
            text-align: center;
            border:.01rem solid #FFBA21;
            border-radius: .42rem;
          }
          .van-stepper{
            width: 1.04rem;
            height: .34rem;
            padding: .01rem .04rem .01rem .04rem;
            border-radius: .43rem;
            background: rgba(255, 255, 255, 0.06);
            border:.01rem solid rgba(255, 231, 85, 0.10);
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        } 
      }
    }


    .ruleWrap{
    width:100%;
    height:100vh;
    background:rgba(0, 0, 0, .9);
    position: fixed;
    top:0;
    left:0;
    z-index:4;
    .ruleContent{
      width:100%;
      height:4.69rem;
      background: url('../assets/back.png') no-repeat;
      background-size: 100% 100%;
      border-top-right-radius: .4rem;
      border-top-left-radius: .4rem;
      position: absolute;
      bottom:0;
      left:0;
      .topfenge{
        width:.4rem;
        height:.05rem;
        background:#fff;
        border-radius: .05rem;
        margin-left: 1.7rem;
        margin-bottom: .2rem;
        margin-top: .2rem;
      }
      .ruleTitle{
        width:100%;
        text-align: center;
        font-size: .17rem;
        color:#fff;
        padding-bottom:10px;
      }
      .ruleBox{
        padding:0 .2rem .2rem .2rem;
        height:3.8rem;
        overflow: hidden;
        overflow-y: scroll;
        scrollbar-width: none;
        .ruleList{
          font-size:.13rem;
          color:#fff;
          line-height: .2rem;
          margin-top:.15rem;
          .ruleListcontent{
            text-align: justify;
            margin-top:.1rem;
          }
        }
      }
    }
  }
}
.nativeWrap{
  width: 100%;
  display: flex;
  // background: linear-gradient(90deg, rgb(43 47 116) 10%, rgb(103 46 123) 100%);
  padding:.1rem;
  justify-content: space-between;
  .backImg{
    display: flex;
    align-items: center;
    margin-top:.35rem;
    .backrightImg{
      width:.2rem;
    }
    .imgName{
      display: flex;
      align-items: center;
      .imgNameimg{
        width:.32rem;
        height:.32rem;
        border-radius: 50%;
        border: .01rem solid #ccc;
        margin-left:.1rem;
      }
      .topName{
        font-size: .13rem;
        color:#fff;
        margin-left:.1rem;
      }
    }
  }
  .rightImg{
    display: block;
    height:.25rem;
    margin-top:.35rem;
  }
}
</style>
<style>
.van-list__finished-text{
  color: #fff;
  font-size: 13px;
  line-height: normal;
  text-align: center;
  padding:.2rem 0 .01rem 0;
  margin-left:-.1rem;
}
.van-stepper__minus{
  width:.24rem !important;
  height:.24rem !important;
  background:none !important;
  color:#FFBA21 !important;
}
.van-stepper__plus{
  width:.24rem !important;
  height:.24rem !important;
  background:none !important;
  color:#FFBA21 !important;
}
.van-stepper__input{
  height:.28rem !important;
  background:rgba(255, 255, 255, 0.02) !important;
  color:#FFBA21 !important;
}
.van-tabs__nav{
  background:none !important;
}
.van-tab{
  color:#fff !important;
}
.van-tabs__line{
  background-color: #8c3eff !important;
}

</style>
